/* ══════════════════════════════════════════════════════════════════════════
   FMT Order Builder
   ──────────────────
   A guided intake that scopes a whole digitisation project, then hands a
   fully-built cart to Shopify checkout.

   Pricing note, important for anyone maintaining this:
   The builder DISPLAYS volume tiers, it does not apply them. Shopify's
   automatic discounts apply the real discount at cart/checkout. The two must
   agree, the ladders in the section settings have to match the automatic
   discount rules in admin. verifyCartTotal() below logs a console warning if
   they drift, so a misconfiguration surfaces in development rather than as a
   customer seeing one number here and another at checkout.
   ══════════════════════════════════════════════════════════════════════════ */

(function () {
  "use strict";

  var root = document.querySelector("[data-fmt-builder]");
  var dataEl = document.querySelector("[data-fmt-catalog]");
  var prodEl = document.querySelector("[data-fmt-products]");
  if (!root || !dataEl || !prodEl) return;

  var CORE = window.FMTBuilderCore;
  if (!CORE) return;
  var CATALOG, PRODUCTS = {}, IMAGES = {};
  try {
    CATALOG = JSON.parse(dataEl.textContent);
    var pd = JSON.parse(prodEl.textContent);
    PRODUCTS = pd.products || {};
    IMAGES = pd.images || {};
    if (pd.truncated) {
      console.warn("[fmt-builder] The store now has more than 50 products, so the " +
        "product map is truncated and some formats may be missing. Split the catalogue " +
        "walk in sections/fmt-order-builder.liquid across pages.");
    }
  } catch (err) {
    console.error("[fmt-builder] catalogue JSON failed to parse", err);
    return;
  }

  /* ─── resolve handles against the product map ─────────────────────────── */
  function imageFor(handle) {
    return (handle && IMAGES[handle]) || "";
  }

  function resolve(handle, match) {
    var v = CORE.resolveVariant(PRODUCTS[handle], match);
    return v ? { vid: v.id, price: v.price, available: true } : { vid: 0, price: 0, available: false };
  }

  function hydrate(o) {
    if (o && o.h) {
      var r = resolve(o.h, o.m);
      o.vid = r.vid;
      o.price = r.price;
      o.available = r.available;
      o.img = imageFor(o.h);
    }
    return o;
  }

  /* A format that quietly does not count toward the volume discount is the
     kind of thing a customer finds before we do -- it looks like the meter is
     broken. Say so at load, once, naming the lines. */
  (function () {
    var mute = [];
    (CATALOG.groups || []).forEach(function (g) {
      if (!g.tiered) { mute.push(g.name + " (whole group)"); return; }
      (g.lines || []).forEach(function (l) {
        if (l.noTier) mute.push(g.name + " \u2192 " + l.label);
      });
    });
    if (mute.length) {
      console.warn("[fmt-builder] These do not count toward the volume discount, so adding them " +
        "will not move the meter: " + mute.join("; ") + ". Intentional? If not, clear the noTier flag " +
        "on the line or the tiered flag on the group in the section settings.");
    }
  })();

  CATALOG.groups = (CATALOG.groups || []).map(function (g) {
    (g.quality || []).forEach(hydrate);
    g.lines = (g.lines || []).map(function (l) {
      hydrate(l);
      (l.quality || []).forEach(hydrate);
      return l;
    }).filter(function (l) {
      // Drop anything whose product has been deleted, so the builder never
      // quotes a price it cannot actually put in a cart.
      if (l.quality && l.quality.length) return l.quality.some(function (q) { return q.vid > 0; });
      if (g.quality && g.quality.length) return true;
      return l.vid > 0;
    });
    return g;
  }).filter(function (g) {
    if (g.quality && g.quality.length) g.quality = g.quality.filter(function (q) { return q.vid > 0; });
    return g.lines.length && (!g.quality || g.quality.length);
  });

  // "Add a Physical Backup" holds both the thumb drives and the disc copies.
  // They are different kinds of decision, so they are split here rather than
  // crammed into one list: you pick one drive, but you might want several discs.
  CATALOG.drives = [{
    k: "none", label: "No USB drive",
    note: "Just the download link. You can always order one later.",
    vid: 0, price: 0, hrs: -1
  }];
  CATALOG.discs = [];
  (CATALOG.backupVariants ? CATALOG.backupVariants.map(function(v){ return Object.assign({},v,{price:v.price/100}); }) : (PRODUCTS[CATALOG.driveHandle] || [])).filter(function (v) { return v.available !== false; }).forEach(function (v) {
    var parts = String(v.title).split(" - ");
    if (/DVD-R|CD-R/.test(v.title)) {
      CATALOG.discs.push({
        k: String(v.id), label: parts[0].replace(/^1\s+/, ""), note: parts[1] || "",
        vid: v.id, price: v.price
      });
      return;
    }
    var hrs = parseFloat(String(parts[1] || "").replace(/[^0-9.]/g, "")) || 0;
    CATALOG.drives.push({
      k: String(v.id), label: parts[0], note: parts[1] || "",
      vid: v.id, price: v.price, hrs: hrs
    });
  });

  var dropVariants = PRODUCTS[CATALOG.dropoffHandle] || [];
  /* The variant reads "Groth Music - Bloomington"; someone choosing between
     six counters is matching on the city, not the shop name, so the city
     leads. Addresses come from section settings rather than the variant title,
     because Shopify has nowhere to put them. */
  var DROP_PLACES = [];
  try { DROP_PLACES = JSON.parse(document.getElementById('fmt-place-data').textContent); } catch(e) {}
  var ADDR = {};
  String(CATALOG.dropoffAddresses || "").split(/[|\n]/).forEach(function (row) {
    var bits = row.split("::");
    if (bits.length >= 2) ADDR[bits[0].trim().toLowerCase()] = bits[1].trim();
  });

  CATALOG.dropoffs = dropVariants.filter(function (v) {
    return String(v.title).indexOf("drop off at") >= 0;
  }).map(function (v) {
    var raw = String(v.title).replace("I will drop off at ", "").trim();
    var parts = raw.split(" - ");
    var vendor = (parts[0] || raw).trim();
    var city = (parts[1] || "").trim();
    /* Match on the FULL title, not the vendor. There are now two "Down In The
       Valley" branches (Golden Valley and Maple Grove), so a vendor-only match
       would hand Maple Grove the Golden Valley photo, caption and map pin. The
       match keys in fmt-place-data.liquid disambiguate on the city half. */
    var hay = raw.toLowerCase();
    var place = DROP_PLACES.find(function(p){return hay.indexOf(p.match)!==-1;});
    return {
      k: String(v.id), vid: v.id, vendor: vendor, city: city, place: place,
      label: city ? city + ", " + vendor : vendor,
      /* Full title first for the same reason: two branches share a vendor name,
         so a vendor-keyed address map would give them both the same street. */
      address: ADDR[raw.toLowerCase()] || ADDR[vendor.toLowerCase()] || ""
    };
  });
  CATALOG.fulfilment = { kitVid: 0, shipVid: 0 };
  dropVariants.forEach(function (v) {
    if (String(v.title).indexOf("Memory Kit") >= 0) CATALOG.fulfilment.kitVid = v.id;
    if (String(v.title).indexOf("package and ship") >= 0) CATALOG.fulfilment.shipVid = v.id;
  });

  /* ─── mail-in kit ─────────────────────────────────────────────────────────
     Replaces the four "mail-in kit" bundles. Those existed to give bulk
     buyers a discount; the volume ladder now does that, so the kit is priced as
     what it is, a padded box, bags and a prepaid return label. If the product
     has not been created yet the option still renders at the fallback price and
     simply adds nothing to the cart, rather than blocking the flow. */
  CATALOG.kit = (function () {
    var r = resolve(CATALOG.kitHandle, null);
    if (!r.vid) {
      console.warn('[fmt-builder] No product found for the mail-in kit handle "' +
        CATALOG.kitHandle + '". The option will show at the fallback price but will ' +
        "not be charged. Create the product and set its handle in the section settings.");
      return { vid: 0, price: (CATALOG.kitFallbackPrice || 1799) / 100 };
    }
    return r;
  })();

  /* ─── extras ──────────────────────────────────────────────────────────────
     Repair, inspection and editing were sold as standalone products nobody
     found. They belong at the point where someone is already thinking about the
     condition of what they are sending. */
  CATALOG.extra = {
    repair: resolve(CATALOG.extras && CATALOG.extras.repairHandle, null),
    editing: resolve(CATALOG.extras && CATALOG.extras.editingHandle, null),
    disc: resolve(CATALOG.extras && CATALOG.extras.discHandle, null)
  };

  /* Every band moved one slower: standard is 3-4 weeks now, and what used to be
     the 1-2 week and under-a-week tiers become 2-3 and 1-2. Prices are
     deliberately untouched -- they stay adaptive by project size.

     m is the Shopify variant lookup key and must NOT change with the label. It
     is how each band finds its product, and resolveVariant() matches it as a
     case-insensitive SUBSTRING of the variant title, requiring exactly one hit.
     So a variant may be retitled freely as long as its keyword survives and
     stays unique within that product; drop or duplicate the keyword and the
     tier silently resolves to $0.

     Shopify now agrees with these labels: the four turnaround products read
     Standard (3-4 weeks) / Expedited (2-3 weeks) / Rush (1-2 weeks). Change one
     side and the cart will contradict this screen, so change both. */
  var TURNAROUND_LABELS = [
    { k: "std",  m: "Standard",  label: "Standard, 3 to 4 weeks",  note: "Our normal queue. Same technicians, same quality." },
    { k: "exp",  m: "Expedited", label: "Expedited, 2 to 3 weeks", note: "Moves ahead of standard work. Good for birthdays and reunions." },
    { k: "rush", m: "Rush",      label: "Rush, 1 to 2 weeks",      note: "Front of the queue, with a completion date confirmed in writing." }
  ];
  var taHandles = String(CATALOG.turnaroundHandles || "").split(",").map(function (s) { return s.trim(); }).filter(Boolean);
  var taCaps = String(CATALOG.turnaroundCaps || "").split(",").map(function (s) { return parseFloat(s) || 0; });
  CATALOG.turnaroundTiers = taHandles.map(function (h, i) {
    return {
      maxSub: taCaps[i] || 0,
      options: TURNAROUND_LABELS.map(function (L) {
        var r = resolve(h, L.m);
        return { k: L.k, label: L.label, note: L.note, vid: r.vid, price: r.price };
      })
    };
  }).filter(function (t) {
    // A band whose product is missing would silently price at $0, drop it.
    return t.options.some(function (o) { return o.vid > 0; });
  });

  // h1 when the builder owns the page, h2 when it sits below a page title.
  var HL = (root.dataset.headingLevel === "h2") ? "h2" : "h1";

  // Bumped when the step order changes: a resumed session stores its step as an
  // index, so v1 state would drop someone onto a screen they never reached.
  /* FMT active visit v1: this tab, at most 60 minutes since real activity. */
  var projectId = "fmt_" + crypto.randomUUID();
  var visitStorage = null, legacyBuilderStorage = null;
  try { visitStorage = window.sessionStorage; } catch (_) {}
  try { legacyBuilderStorage = localStorage; } catch (_) {}
  var visit = window.FMTBuilderSession ? window.FMTBuilderSession.create({
    storage: visitStorage, legacyStorage: legacyBuilderStorage,
    createId: function () { return "fmt_" + crypto.randomUUID(); }
  }) : null;

  var STEPS = [
    { key: "what", rail: "Your media" },
    { key: "many", rail: "Quantities" },
    { key: "who", rail: "Save progress" },
    { key: "to", rail: "Getting it here" },
    { key: "back", rail: "Files & timing" },
    { key: "fix", rail: "Photo correction" },
    { key: "done", rail: "Review" }
  ];

  // Step counters are derived so adding a step cannot leave "Step 5 of 7"
  // stranded somewhere.
  function stepIndex(key) {
    for (var i = 0; i < STEPS.length; i++) {
      if (STEPS[i].key === key) return i;
    }
    return -1;
  }

  function stepLabel(key) {
    for (var i = 0; i < STEPS.length; i++) {
      if (STEPS[i].key === key) return "Step " + stepPos(i) + " of " + stepTotal();
    }
    return "";
  }

  var ICONS = {
    disc: '<circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="2.5"/><path d="M5 7l3 2M16 15l3 2"/>',
    tape: '<path d="M2 6.2h20v11.6H2z"/><circle cx="8" cy="12" r="2.4"/><circle cx="16" cy="12" r="2.4"/><path d="M5 17.8v1.4M19 17.8v1.4"/>',
    film: '<circle cx="12" cy="12" r="9.2"/><circle cx="12" cy="12" r="2.1"/><circle cx="12" cy="6.3" r="1.6"/><circle cx="16.9" cy="14.8" r="1.6"/><circle cx="7.1" cy="14.8" r="1.6"/>',
    photo: '<path d="M3 5.6h18v12.8H3z"/><circle cx="8.6" cy="10.2" r="1.7"/><path d="m3 16 5.2-4.4L13 16"/><path d="m13 16 3.4-2.8L21 16.6"/>',
    slide: '<path d="M4.4 3.6h15.2v16.8H4.4z"/><path d="M7.4 7h9.2v10H7.4z"/>',
    audio: '<path d="M2.6 6.6h18.8v10.8H2.6z"/><circle cx="8.4" cy="12" r="1.9"/><circle cx="15.6" cy="12" r="1.9"/><path d="M8.4 15.4h7.2"/>',
    pro: '<path d="M3 7.4h13.2v9.2H3z"/><path d="m16.2 11 4.8-2.6v7.2L16.2 13z"/><circle cx="7" cy="12" r="1.5"/>',
    help: '<circle cx="12" cy="12" r="9.2"/><path d="M9.4 9.4a2.7 2.7 0 1 1 3.4 2.6c-.5.2-.8.7-.8 1.3v.5"/><path d="M12 17.1v.05"/>',
    bolt: '<path d="M12 3.2 4.2 12h6l-1.4 8.8L19.8 11h-6l1.2-7.8Z"/>',
    check: '<path d="M20 6.5 9.4 17 4 11.6"/>'
  };

  /* ─── state ───────────────────────────────────────────────────────────── */
  var S = {
    step: 0,
    reached: 0,
    fixLevel: "none",
    fixQty: 0,
    keepOriginals: true,
    notes: "",
    formats: [],
    qty: {},
    quality: {},
    openGroups: {},
    email: "",
    name: "",
    marketing: false,
    logistics: null,
    dropoff: null,
    drive: "none",
    driveQty: 1,
    speed: "std",
    repairQty: 0,
    // The step that used to ask for this is gone, and the promise that replaced
    // it says we inspect everything -- so this is simply true now, and the order
    // property ops reads from stays accurate.
    inspectFirst: true,
    editingQty: 0,
    discs: {},
    quoteMode: false,
    error: ""
  };

  /* What travels in a resume link. Everything the order is made of, and
     nothing about the person -- see the note at the top of this block. */
  var PORTABLE = ["step", "reached", "formats", "qty", "quality", "openGroups",
    "logistics", "dropoff", "drive", "driveQty", "speed", "repairQty", "inspectFirst",
    "fixLevel", "fixQty", "keepOriginals",
    "editingQty", "discs"];

  // base64url: a plain base64 payload carries + / and = , which have to be
  // percent-encoded in a query string and get mangled by some mail clients.
  function encodeOrder(forRecovery) {
    var slim = { version: 3 };
    PORTABLE.forEach(function (k) { if (k in S) slim[k] = S[k]; });
    if (forRecovery && S.step === stepIndex('who')) {
      slim.step = stepIndex('to'); slim.reached = Math.max(slim.reached || 0, slim.step);
    }
    try {
      return btoa(unescape(encodeURIComponent(JSON.stringify(slim))))
        .replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
    } catch (e) { return ""; }
  }

  function decodeOrder(str) {
    try {
      if (typeof str !== "string" || str.length > 20000) return null;
      var b = str.replace(/-/g, "+").replace(/_/g, "/");
      while (b.length % 4) { b += "="; }
      var o = JSON.parse(decodeURIComponent(escape(atob(b))));
      if (o) { o.keepOriginals = true; o.email = ""; o.name = ""; o.notes = ""; o.marketing = false; if (!o.version || o.version < 2) { if (o.step >= 2) o.step++; if (o.reached >= 2) o.reached++; } if (!o.version || o.version < 3) { if (o.step >= 5) o.step++; if (o.reached >= 5) o.reached++; } }
      return (o && Array.isArray(o.formats) && o.formats.length) ? CORE.normalize(o, CATALOG, DEFAULTS, STEPS.length) : null;
    } catch (e) { return null; }
  }

  /* The link an abandonment email should point at. Absolute, because it is
     going into an email rather than onto a page. */
  function resumeUrl(forRecovery) {
    var code = encodeOrder(forRecovery);
    if (!code) return "";
    return window.location.origin + window.location.pathname + "?o=" + code + (root.dataset.previewTheme ? "&preview_theme_id=" + encodeURIComponent(root.dataset.previewTheme) : "");
  }

  var DEFAULTS = JSON.parse(JSON.stringify(S));
  var restored = false;
  var restoredStep = 0;

  // Explicit links always win, even when this tab has an expired draft.
  var fromLink = null;
  try { fromLink = decodeOrder(new URLSearchParams(window.location.search).get('o')); } catch (_) {}
  var initialVisit = visit ? visit.load(fromLink) : { projectId: projectId, state: fromLink, restored: !!fromLink };
  projectId = initialVisit.projectId;
  if (initialVisit.state) {
    S = CORE.normalize(initialVisit.state, CATALOG, DEFAULTS, STEPS.length);
    S.error = ''; S.quoteMode = false;
    restored = initialVisit.restored && S.formats.length > 0 && S.step > 0;
    restoredStep = S.step;
  }
  // Remove only the consumed snapshot. Keep preview, format and hash context.
  try {
    var cleanParams = new URLSearchParams(window.location.search);
    if (cleanParams.has('o') && window.history && window.history.replaceState) {
      cleanParams.delete('o');
      var query = cleanParams.toString();
      window.history.replaceState(window.history.state || {}, '', window.location.pathname + (query ? '?' + query : '') + (window.location.hash || ''));
    }
  } catch (_) {}

  function normalizeSelection() {
    var error = S.error, quote = S.quoteMode;
    S = CORE.normalize(S, CATALOG, DEFAULTS, STEPS.length);
    S.error = error; S.quoteMode = quote;
    if (!hasImages()) { S.fixLevel='none'; S.fixQty=0; }
    else S.fixQty=Math.min(imageCount(),Math.max(0,parseInt(S.fixQty,10)||0));
  }
  function applyContextFormat() {
    var selectedParam = new URLSearchParams(window.location.search).get('format') || new URLSearchParams((window.location.hash || '').slice(1)).get('format');
    if (selectedParam && CATALOG.groups.some(function (g) { return g.id === selectedParam; }) && S.formats.indexOf(selectedParam) < 0) {
      S.formats = S.formats.filter(function (id) { return id !== 'unsure'; });
      S.formats.push(selectedParam); S.openGroups[selectedParam] = true;
    }
  }
  if (!fromLink) applyContextFormat();
  function persist() {
    if (visit) visit.save(S); // Saving a render is not evidence of activity.
    if (recovery) recovery.update(); // Storage failure must not disable email updates.
  }

  /* ─── money & tiers ───────────────────────────────────────────────────── */
  function money(n) {
    return "$" + Number(n || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  // "300:10,750:17,1500:25" -> [{min:300,pct:10}, ...] where min is dollars.
  function parseLadder(str) {
    if (!str) return [];
    return String(str).split(",").map(function (pair) {
      var bits = pair.split(":");
      return { min: parseFloat(bits[0]) || 0, pct: parseFloat(bits[1]) || 0 };
    }).filter(function (t) { return t.min > 0; }).sort(function (a, b) { return a.min - b.min; });
  }

  var LADDER = parseLadder(CATALOG.valueLadder);

  function group(id) {
    for (var i = 0; i < CATALOG.groups.length; i++) {
      if (CATALOG.groups[i].id === id) return CATALOG.groups[i];
    }
    return null;
  }

  // The quality *choice* is made once per group, but a line may resolve that
  // choice against its own product, negatives are priced identically to slides
  // yet are a separate product, and ops needs the right one on the order.
  function qualityFor(g, line) {
    if (line && line.fixedQuality) return null;
    var set = (line && line.quality && line.quality.length) ? line.quality : g.quality;
    if (!set || !set.length) return null;
    var chosen = S.quality[g.id];
    for (var i = 0; i < set.length; i++) {
      if (set[i].k === chosen) return set[i];
    }
    return set[0];
  }

  // Unit list price for a line, before any volume discount.
  function listPrice(g, line) {
    var q = qualityFor(g, line);
    if (q) return q.price;
    return line.price || 0;
  }
  function variantFor(g, line) {
    var q = qualityFor(g, line);
    if (q) return q.vid;
    return line.vid || 0;
  }

  function countIn(g) {
    return g.lines.reduce(function (sum, l) {
      return sum + (S.qty[g.id + ":" + l.k] || 0);
    }, 0);
  }

  /* What the discount is measured against: the list value of every format that
     opts into the ladder, before anything comes off. Reading it off the
     discounted total instead would be circular, applying a rung could drop the
     order back below the rung that granted it. Shopify's minimum-purchase
     condition is evaluated the same way, so the two agree. */
  function tieredSubtotal() {
    var sum = 0;
    S.formats.forEach(function (id) {
      var g = group(id);
      if (!g || !g.tiered) return;
      g.lines.forEach(function (l) {
        if (l.noTier) return;
        sum += CORE.cents(listPrice(g, l)) * (S.qty[g.id + ":" + l.k] || 0);
      });
    });
    return sum / 100;
  }

  // One rate for the whole order. Every opted-in format earns it together.
  function discountPct() {
    if (!LADDER.length) return 0;
    var v = tieredSubtotal(), pct = 0;
    LADDER.forEach(function (t) { if (v >= t.min) pct = t.pct; });
    return pct;
  }

  /* One progress model, read by the format headers, the receipt strip and the
     big meter, so three readouts cannot disagree with each other. */
  function ladderProgress() {
    if (!LADDER.length) return null;
    var v = tieredSubtotal();
    var floor = 0;
    LADDER.forEach(function (t) { if (v >= t.min) floor = t.min; });
    var next = nextRung();
    var frac = next ? (v - floor) / (next.t.min - floor) : 1;
    return {
      v: v,
      pct: discountPct(),
      next: next,
      frac: Math.max(0, Math.min(1, frac)),
      label: next ? money(next.gap) + " to " + next.t.pct + "% off" : "Best rate reached"
    };
  }

  function miniBar(p, extra) {
    return '<span class="fmt-mini' + (extra ? " " + extra : "") + '" role="img" ' +
      'aria-label="' + esc(p.label) + '" title="' + esc(p.label) + '">' +
      '<span class="fmt-mini__fill" style="width:' + (p.frac * 100).toFixed(1) + '%"></span></span>';
  }

  // What sits on the right of a format block's header.
  function headProgress(g) {
    var p = ladderProgress();
    if (!p || !g.tiered) return "";
    return miniBar(p) + '<span class="fmt-qhead__rate">' +
      esc(p.pct ? p.pct + "% off applied" : p.label) + "</span>";
  }

  // The rung above the current one, and what it would take to get there.
  function nextRung() {
    var v = tieredSubtotal();
    for (var i = 0; i < LADDER.length; i++) {
      if (v < LADDER[i].min) return { t: LADDER[i], gap: LADDER[i].min - v };
    }
    return null;
  }

  function discountedUnit(price, rate) {
    var cents = CORE.cents(price);
    return (cents - Math.floor(cents * rate / 100)) / 100;
  }

  function lineItems() {
    var out = [];
    var pct = discountPct();
    S.formats.forEach(function (id) {
      var g = group(id);
      if (!g) return;
      var rate = g.tiered ? pct : 0;
      g.lines.forEach(function (l) {
        var q = S.qty[g.id + ":" + l.k] || 0;
        if (!q) return;
        var list = listPrice(g, l);
        var eff = l.noTier ? list : discountedUnit(list, rate);
        out.push({
          g: g, l: l, q: q,
          vid: variantFor(g, l),
          list: list,
          unit: eff,
          sub: CORE.cents(eff) * q / 100,
          saved: (CORE.cents(list) - CORE.cents(eff)) * q / 100
        });
      });
    });
    return out;
  }

  function contentHours() {
    return lineItems().reduce(function (s, i) { return s + i.q * (i.g.hours || 0); }, 0);
  }

  /* Gigabytes the finished files will occupy. Sized per item and per quality
     tier from CATALOG.storageGb, because the group-level "hours" field cannot
     express either end of this: photos have no runtime at all, and a 2400 dpi
     TIFF is 137 times the size of the 600 dpi JPEG of the same print. */
  function gbFor(g, line, qty) {
    var map = CATALOG.storageGb || {};
    var qo = qualityFor(g, line);
    var q = qo ? qo.k : "";
    var base = g.id + ":" + line.k;
    var v = map[base + ":" + q];
    if (v === undefined) v = map[base];
    if (v === undefined) v = (g.hours || 0) * 3.7;   // last resort, at the standard rate
    return v * qty;
  }

  function contentGb() {
    return lineItems().reduce(function (s, i) { return s + gbFor(i.g, i.l, i.q); }, 0);
  }

  /* Labelled capacity is not usable capacity -- a "16GB" stick formats to about
     14.8 -- and an order sized to exactly fill a drive is an order that does not
     fit. 0.93 for formatting, 1.10 for headroom. */
  function driveCapacityGb(d) {
    var m = String(d.label || "").match(/(\d+)\s*(GB|TB)/i);
    if (!m) return 0;
    var n = parseFloat(m[1]);
    if (/TB/i.test(m[2])) n *= 1000;
    return n * 0.93;
  }

  /* Returns the drive to offer and how many of it. Quantity is what makes the
     Premium-TIFF case answerable at all: at ~0.55 GB a print, 860 prints beat
     the largest drive sold, so the honest answer is two drives rather than a
     recommendation that silently will not fit. */
  function unknownStorageSize() {
    return lineItems().some(function (i) { return (i.g.id === 'photo' && i.l.k === 'oversized') || (i.g.id === 'pro' && i.l.k === 'dvcpl'); });
  }
  function driveNeed() {
    if (unknownStorageSize()) {
      var fallback = CATALOG.drives.find(function(d){return /\b64\s*GB\b/i.test(d.label);});
      var knownNeed = contentGb() * 1.10;
      return {drive:fallback || null, qty:Math.max(1,Math.ceil(knownNeed / (fallback ? driveCapacityGb(fallback) : 64))), need:knownNeed, provisional:true};
    }
    var need = contentGb() * 1.10;
    if (!need && !lineItems().length) return { drive: null, qty: 1, need: 0 };
    var real = CATALOG.drives.filter(function (d) { return driveCapacityGb(d) > 0; })
      .sort(function (a, b) { return driveCapacityGb(a) - driveCapacityGb(b); });
    if (!real.length) return { drive: null, qty: 1, need: need };
    for (var i = 0; i < real.length; i++) {
      if (driveCapacityGb(real[i]) >= need) return { drive: real[i], qty: 1, need: need };
    }
    var big = real[real.length - 1];
    return { drive: big, qty: Math.ceil(need / driveCapacityGb(big)), need: need };
  }

  function gbLabel(gb) {
    if (gb >= 1000) return (gb / 1000).toFixed(gb >= 10000 ? 0 : 1) + " TB";
    if (gb >= 10) return Math.round(gb) + " GB";
    if (gb >= 1) return gb.toFixed(1) + " GB";
    return Math.max(1, Math.round(gb * 1000)) + " MB";
  }
  function driveObj() {
    for (var i = 0; i < CATALOG.drives.length; i++) {
      if (String(CATALOG.drives[i].k) === String(S.drive)) return CATALOG.drives[i];
    }
    return CATALOG.drives[0];
  }
  // Turnaround is banded by project size, pick the band, then the choice.
  function turnaroundSet() {
    var tiers = CATALOG.turnaroundTiers || [];
    if (!tiers.length) return [];
    var sub = lineItems().reduce(function (s, i) { return s + CORE.cents(i.sub); }, 0) / 100;
    for (var i = 0; i < tiers.length; i++) {
      var cap = tiers[i].maxSub;
      if (!cap || sub <= cap) return tiers[i].options || [];
    }
    return tiers[tiers.length - 1].options || [];
  }
  function speedObj() {
    var set = turnaroundSet();
    for (var i = 0; i < set.length; i++) if (set[i].k === S.speed) return set[i];
    return set[0] || { k: "std", label: "Standard, 3 to 4 weeks", price: 0, vid: 0 };
  }
  function recommendedDrive() {
    var h = contentHours();
    if (!h) return null;
    var best = null;
    CATALOG.drives.forEach(function (d) {
      if (d.hrs > 0 && d.hrs >= h && (!best || d.hrs < best.hrs)) best = d;
    });
    if (!best) {
      CATALOG.drives.forEach(function (d) {
        if (d.hrs > 0 && (!best || d.hrs > best.hrs)) best = d;
      });
    }
    return best;
  }

  function orderBeforeKit() {
    var d=driveObj(),sp=speedObj();
    return lineItems().reduce(function(s,i){return s+CORE.cents(i.sub);},0) +
      (d&&d.vid?CORE.cents(d.price)*Math.max(1,parseInt(S.driveQty,10)||1):0) +
      (sp&&sp.k!=='std'?CORE.cents(sp.price):0) +
      discLines().reduce(function(s,x){return s+CORE.cents(x.d.price)*x.qty;},0) +
      extrasLines().reduce(function(s,x){return s+CORE.cents(x.unit)*x.qty;},0) + CORE.cents(fixTotal());
  }
  function kitOption() {
    var small=orderBeforeKit()<=25000;
    var title=small?'$250 or less':'Over $250';
    var v=(PRODUCTS[CATALOG.kitHandle]||[]).find(function(v){return v.title===title&&v.available!==false;});
    return {vid:v?v.id:0,price:v?v.price:(small?9.99:17.99)};
  }
  function kitPrice() { return S.logistics==='kit'?kitOption().price:0; }

  function extrasLines() {
    var out = [];
    if (false && S.repairQty > 0 && CATALOG.extra.repair.price) {
      out.push({ k: "repair", label: "Tape / media repair", qty: S.repairQty,
                 unit: CATALOG.extra.repair.price, vid: CATALOG.extra.repair.vid });
    }
    if (false && S.editingQty > 0 && CATALOG.extra.editing.price) {
      out.push({ k: "editing", label: "Custom editing", qty: S.editingQty,
                 unit: CATALOG.extra.editing.price, vid: CATALOG.extra.editing.vid });
    }
    return out;
  }

  // Discs sit with delivery, not with extras, so they total separately.
  function discLines() {
    return (CATALOG.discs || []).map(function (d) {
      return { d: d, qty: S.discs[d.k] || 0 };
    }).filter(function (x) { return x.qty > 0; });
  }

  function totals() {
    normalizeSelection();
    var items = lineItems();
    var sub = items.reduce(function (s, i) { return s + CORE.cents(i.sub); }, 0) / 100;
    var saved = items.reduce(function (s, i) { return s + CORE.cents(i.saved); }, 0) / 100;
    var d = driveObj(), sp = speedObj();
    var drive = d && d.vid ? d.price * Math.max(1, parseInt(S.driveQty, 10) || 1) : 0;
    var speed = sp && sp.k !== "std" ? sp.price : 0;
    var kit = kitPrice();
    var extras = extrasLines();
    var extraSum = extras.reduce(function (s, e) { return s + e.unit * e.qty; }, 0);
    var discs = discLines();
    var discSum = discs.reduce(function (s, x) { return s + x.d.price * x.qty; }, 0);
    return {
      items: items, sub: sub, saved: saved, drive: drive, speed: speed,
      kit: kit, extras: extras, extraSum: extraSum,
      discs: discs, discSum: discSum,
      fix: fixTotal(),
      total: [sub, drive, speed, kit, extraSum, discSum, fixTotal()].reduce(function (sum, value) { return sum + CORE.cents(value); }, 0) / 100
    };
  }

  /* ─── markup helpers ──────────────────────────────────────────────────── */
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }
  function svg(path, cls) {
    return '<svg class="' + cls + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
      'stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + path + "</svg>";
  }
  function priceFrom(g) {
    var lo = null;
    if (g.quality && g.quality.length) {
      g.quality.forEach(function (q) { if (lo === null || q.price < lo) lo = q.price; });
    } else {
      g.lines.forEach(function (l) { if (l.price && (lo === null || l.price < lo)) lo = l.price; });
    }
    if (lo === null) return "";
    /* List price, deliberately. This used to apply the deepest ladder tier --
       32% off -- before the customer had picked a format, so it showed a price
       that needs $3,000 of order value to reach and disagreed with every other
       page on the site. The volume ladder is on screen beside this, and the
       estimate drops live as the order grows; neither needs a number here that
       nobody can get yet. */
    return "from " + money(lo) + " each";
  }

  /* ─── views ───────────────────────────────────────────────────────────── */
  /* A group has no handle of its own, but its first line does, and that
     product's featured image is the photograph of the format. Falls back to the
     line icon, so a group whose product has no image still lines up in the grid
     rather than collapsing. */
  function groupImage(g) {
    // The group's own choice first. Falling back to a line handle covers any
    // group added later without one, rather than leaving a hole in the grid.
    var own = imageFor(g.img);
    if (own) return own;
    var lines = g.lines || [];
    for (var i = 0; i < lines.length; i++) {
      var src = imageFor(lines[i].h);
      if (src) return src;
    }
    return "";
  }

  function viewWhat() {
    var tiles = CATALOG.groups.map(function (g) {
      var shot = groupImage(g);
      return '<button type="button" class="fmt-tile" data-fmt="' + esc(g.id) + '" aria-pressed="' +
        (S.formats.indexOf(g.id) >= 0) + '">' +
        (shot
          ? '<span class="fmt-tile__shot"><img src="' + esc(shot) + '" alt="" loading="lazy" ' +
            'width="72" height="72"></span>'
          : '<span class="fmt-tile__shot fmt-tile__shot--icon">' +
            svg(ICONS[g.icon] || ICONS.help, "fmt-tile__ic") + "</span>") +
        '<span class="fmt-tile__t-wrap"><span class="fmt-tile__t">' + esc(g.name) + "</span>" +
        '<span class="fmt-tile__d">' + esc(({tape:'VHS & camcorder tapes',film:'8mm, Super 8 & 16mm',photo:'Prints & albums',slide:'Slides & negative strips',audio:'Cassettes & audio reels',pro:'Broadcast & studio formats'})[g.id] || g.desc) + "</span>" +
        '<span class="fmt-tile__p">' + esc(priceFrom(g)) + "</span></span>" +
        '<span class="fmt-tile__chk"></span></button>';
    }).join("");

    /* No photograph for "I'm not sure" -- there is nothing to photograph. The
       icon keeps it the same shape as the rest so the grid stays even. */
    tiles += '<button type="button" class="fmt-tile fmt-tile--unsure" data-fmt="unsure" aria-pressed="' +
      (S.formats.indexOf("unsure") >= 0) + '">' +
      '<span class="fmt-tile__shot fmt-tile__shot--icon">' + svg(ICONS.help, "fmt-tile__ic") + "</span>" +
      '<span class="fmt-tile__t-wrap"><span class="fmt-tile__t">I\'m not sure what I have</span>' +
      '<span class="fmt-tile__d">We can help identify your media before you order</span>' +
      '<span class="fmt-tile__p">No charge to find out</span></span>' +
      '<span class="fmt-tile__chk"></span></button>';

    return '<p class="fmt-step__eyebrow">' + stepLabel("what") + '</p>' +
      '<' + HL + ' class="fmt-step__h">What\'s in the box?</' + HL + '>' +
      '<p class="fmt-step__sub">Choose all the types you have. You can change this later.</p>' +
      '<div class="fmt-fields"><div class="fmt-tiles">' + tiles + "</div></div>";
  }

  /* One explicit question rather than a silent subscribe. Someone typing an
     address to save an estimate has not agreed to a monthly newsletter, and a
     list built without asking is the fastest way to a complaint rate that stops
     your email reaching anyone at all -- including the people who did want it. */
  function optInRow() {
    var cfg = CATALOG.marketingOptIn || {};
    if (cfg.show === false) return "";
    return '<label class="fmt-optin">' +
      '<input type="checkbox" data-optin' + (S.marketing ? " checked" : "") + ">" +
      "<span>" + esc(cfg.label || "Send me occasional tips on caring for old media, and the odd offer.") +
      "</span></label>";
  }

  function viewWho() {
    var state = recovery ? recovery.getStatus() : { message: '' };
    return '<p class="fmt-step__eyebrow">' + stepLabel('who') + '</p>' +
      '<' + HL + ' class="fmt-step__h">Save your place.</' + HL + '>' +
      '<p class="fmt-step__sub" id="fmt-email-help">Email yourself a link to resume later, or continue without email.</p>' +
      '<div class="fmt-recovery-panel"><div class="fmt-row2">' +
      '<div><label class="fmt-label" for="fmt-email">Email address <span class="fmt-hint">(to save by email)</span></label><input type="email" id="fmt-email" autocomplete="email" inputmode="email" autocapitalize="none" spellcheck="false" aria-describedby="fmt-email-help" maxlength="254" value="' + esc(S.email) + '"></div>' +
      '<div><label class="fmt-label" for="fmt-name">First name <span class="fmt-hint">(optional)</span></label><input type="text" id="fmt-name" autocomplete="given-name" maxlength="100" value="' + esc(S.name) + '"></div></div>' +
      '<label class="fmt-recovery-consent"><input type="checkbox" id="fmt-recovery-consent" aria-describedby="fmt-email-privacy" data-recovery-consent' + (recoveryConsent ? ' checked' : '') + '><span>Email me a link to this project and reminders to finish it.</span></label>' +
      '<p class="fmt-hint" id="fmt-email-privacy">This saves your project with Family Media Transfer. It does not add you to our general newsletter. <a href="/policies/privacy-policy">Privacy policy</a></p>' +
      '<div class="fmt-recovery-status" data-recovery-status role="status"' + (state.message ? '' : ' hidden') + '>' + esc(state.message) + '</div>' +
      (recovery && recovery.getContext && recovery.getContext() ? '<p class="fmt-hint">Already requested an email? Continuing without email does not cancel that request. Uncheck the permission above to stop future project reminders.</p>' : '') +
      '</div>';
  }

  function qualityPicker(g) {
    var cur = qualityFor(g);
    return '<div class="fmt-qual" role="group" aria-label="Scan quality for ' + esc(g.name) + '"><span class="fmt-label">Scan quality</span><div class="fmt-choices">' +
      g.quality.map(function (o) {
        return '<button type="button" class="fmt-choice" data-qual="' + esc(g.id) + ":" + esc(o.k) +
          '" aria-pressed="' + (cur && cur.k === o.k) + '">' +
          '<span class="fmt-radio"></span><span class="fmt-choice__t"><b>' + esc(o.label) + "</b>" +
          '<span class="fmt-choice__d">' + esc(o.note) + "</span></span>" +
          '<span class="fmt-choice__p">' + money(o.price) + "</span></button>";
      }).join("") + "</div></div>";
  }

  /* One meter for the order rather than one per format. The old per-format
     meters each nagged for more of their own thing, which is exactly the
     behaviour the value ladder exists to remove: a customer with tapes, photos
     and slides should see one number moving, not three competing ones. */
  function valueMeter() {
    if (!LADDER.length) return "";
    var v = tieredSubtotal();
    var pct = discountPct();

    var chips = '<ul class="fmt-ladder">' + LADDER.map(function (t) {
      return '<li class="' + (pct === t.pct && v >= t.min ? "is-on" : "") + '">' +
        money(t.min).replace(".00", "") + "+ · " + t.pct + "% off</li>";
    }).join("") + "</ul>";

    if (!v) {
      return '<div class="fmt-tier is-idle">' + svg(ICONS.bolt, "fmt-tier__bolt") +
        "<div><b>Volume pricing applies to your whole order.</b>" +
        '<span class="fmt-tier__long"> Mix formats freely, tapes, photos, slides and film all count ' +
        "toward the same discount, so you never have to send more of one thing to earn it.</span>" +
        chips + "</div></div>";
    }

    var next = nextRung();
    var saved = lineItems().reduce(function (s, i) { return s + i.saved; }, 0);
    var msg = saved > 0
      ? "<b>" + money(saved) + " off</b>, " + pct + "% volume discount on " + money(v) + " of digitizing."
      : "<b>" + money(v) + "</b> of digitizing so far.";
    var nextMsg = next
      ? " Another <b>" + money(next.gap) + "</b> reaches <b>" + next.t.pct + "% off</b>."
      : " You're at our best rate.";

    return '<div class="fmt-tier' + (saved > 0 ? "" : " is-idle") + '">' + svg(ICONS.bolt, "fmt-tier__bolt") +
      "<div>" + msg + nextMsg + chips + "</div></div>";
  }

  function viewMany() {
    var chosen = S.formats.filter(function (id) { return id !== "unsure"; });
    if (!chosen.length) {
      return '<p class="fmt-step__eyebrow">' + stepLabel("many") + '</p>' +
        '<' + HL + ' class="fmt-step__h">How much of each?</' + HL + '>' +
        '<p class="fmt-step__sub">You told us you\'re not sure what you have, that\'s completely fine. Skip ahead ' +
        "and we'll count and identify everything when it arrives, then send you an itemised estimate before any " +
        "work begins.</p>";
    }

    var pct = discountPct();
    /* One format: no point collapsing it. More than one, and the step is a
       short list of headers instead of several hundred pixels of rows. A
       section you have already put numbers into stays open regardless. */
    var single = chosen.length < 2;
    var blocks = chosen.map(function (id) {
      var g = group(id);
      if (!g) return "";
      var rate = g.tiered ? pct : 0;
      var count = countIn(g);
      /* A section with quantities in it opens by default, so going back to
         check never hides your own answers -- but the default is only a
         default. Once you have said which way you want it, that wins. */
      var chose = S.openGroups[g.id];
      var open = single || (chose === undefined ? count > 0 : chose === true);
      var rows = g.lines.map(function (l) {
        var key = g.id + ":" + l.k;
        var q = S.qty[key] || 0;
        var list = listPrice(g, l);
        var eff = l.noTier ? list : discountedUnit(list, rate);
        /* A line without its own product borrows the picture from whichever
           quality option it resolves against, photo prints live entirely on
           the group's quality set and have no handle of their own. */
        var qual = qualityFor(g, l);
        // Falls through to the group photograph so photo and slide rows, whose
        // lines carry no product handle, show the format rather than a blank.
        var thumb = l.img || (qual && qual.img) || groupImage(g) || "";
        return '<div class="fmt-qrow">' +
          (thumb ? '<img class="fmt-qrow__img" src="' + esc(thumb) + '" alt="" loading="lazy" ' +
            'width="52" height="52">' : '<span class="fmt-qrow__img fmt-qrow__img--none" aria-hidden="true"></span>') +
          '<span class="fmt-qrow__lbl"><b>' + esc(l.label) + "</b>" +
          "<span>" + esc(l.note) + (list ? " · " + money(list) : "") + "</span></span>" +
          '<span class="fmt-stepper">' +
          '<button type="button" data-dec="' + key + '" aria-label="Fewer ' + esc(l.label) + '">&minus;</button>' +
          '<input type="number" min="0" inputmode="numeric" value="' + q + '" data-qty="' + key +
          '" aria-label="Number of ' + esc(l.label) + '">' +
          '<button type="button" data-inc="' + key + '" aria-label="More ' + esc(l.label) + '">+</button>' +
          "</span>" +
          '<span class="fmt-qrow__amt">' + (money(eff * q)) + "</span></div>";
      }).join("");

      var head = svg(ICONS[g.icon] || ICONS.help, "fmt-qhead__ic") +
        '<span class="fmt-qhead__t">' + esc(g.name) + "</span>" +
        (single
          ? '<span class="fmt-qhead__prog" data-prog>' + headProgress(g) + "</span>"
          : '<span class="fmt-qhead__count">' +
            (count ? count + " " + esc(g.unit) + (count > 1 ? "s" : "") : "Add") +
            "</span>" + '<span class="fmt-qhead__chev" aria-hidden="true"></span>');

      return '<div class="fmt-qblock' + (open ? " is-open" : "") + '" data-group="' + esc(g.id) + '">' +
        (single
          ? '<div class="fmt-qhead">' + head + "</div>"
          : '<button type="button" class="fmt-qhead fmt-qhead--toggle" data-gtoggle="' + esc(g.id) +
            '" aria-expanded="' + (open ? "true" : "false") + '">' + head + "</button>") +
        '<div class="fmt-qbody"' + (open ? "" : " hidden") + ">" +
        (g.quality ? qualityPicker(g) : "") + rows +
        (single ? "" : '<div class="fmt-qhead__prog fmt-qhead__prog--inline" data-prog>' + headProgress(g) + "</div>") +
        "</div></div>";
    }).join("");

    return '<p class="fmt-step__eyebrow">' + stepLabel("many") + '</p>' +
      '<' + HL + ' class="fmt-step__h">How much of each?</' + HL + '>' +
      '<p class="fmt-step__sub">Rough counts are fine, we recount on arrival and adjust before starting. ' +
      "Every format counts toward the same discount.</p>" +
      '<p class="fmt-hint" id="fmt-quantity-help">Enter a whole-number count beside each item you have. Leave other items at 0.</p>' +
      '<div class="fmt-fields">' + blocks + valueMeter() +
      "</div>";
  }

  function viewTo() {
    /* City in bold and first, vendor under it, then the street. Someone
       choosing between six counters is deciding which one they drive past,
       so the city has to be the thing the eye lands on.

       The map is a separate control rather than the whole row being a link:
       the row's job is to select a counter, and one target should do one
       thing. */
    var locs = CATALOG.dropoffs.map(function (d) {
      /* Two lines and a link. The city answers whether a counter is near you,
         the host business is what you look for when you get there, and the
         street address lives in Maps where you were going to open it anyway. */
      return '<div class="fmt-drop">' +
        '<button type="button" class="fmt-choice fmt-drop__pick" data-drop="' + esc(d.k) + '" aria-pressed="' +
        (String(S.dropoff) === String(d.k)) + '">' +
        '<span class="fmt-radio"></span>' +
        '<span class="fmt-choice__t"><b>' + esc(d.city || d.vendor) + "</b>" +
        (d.city ? '<span class="fmt-drop__vendor">' + esc(d.vendor) + "</span>" : "") +
        "</span></button>" +
        (d.address
          ? '<a class="fmt-drop__dir" target="_blank" rel="noopener" ' +
            'href="' + esc(d.place ? d.place.map : 'https://www.google.com/maps/search/?api=1&query='+encodeURIComponent(d.address)) + '" aria-label="Directions to FMT drop-off at '+esc(d.vendor)+'">Directions <svg class="fmt-arrow" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 19 19 5M5 5h14v14"/></svg></a>'
          : "") +
        (d.place ? '<button type="button" class="fmt-place-photo" data-fmt-photo="'+esc(d.place.photo)+'" data-fmt-photo-title="'+esc(d.vendor)+'" data-fmt-photo-caption="'+esc(d.place.caption)+'" data-fmt-photo-map="'+esc(d.place.map)+'" aria-label="View location photo: '+esc(d.vendor)+'"><img src="'+esc(d.place.photo)+'" alt="" width="60" height="70" loading="lazy"></button>' : '') +
        "</div>";
    }).join("");

    return '<p class="fmt-step__eyebrow">' + stepLabel("to") + '</p>' +
      '<' + HL + ' class="fmt-step__h">How should we receive your media?</' + HL + '>' +
      '<div class="fmt-fields"><div class="fmt-choices">' +
      '<button type="button" class="fmt-choice fmt-choice--shot fmt-choice--pick" data-log="kit" aria-pressed="' +
      (S.logistics === "kit") + '">' +
      '<span class="fmt-radio"></span>' +
      (CATALOG.kitImage
        ? '<img class="fmt-choice__shot" src="' + esc(CATALOG.kitImage) + '" alt="" loading="lazy">'
        : "") +
      '<span class="fmt-choice__t">' +
      '<b>Send me a mail-in kit</b>' +
      '<span class="fmt-choice__d"><span class="fmt-choice__fit">Best if you\'d rather not drive.</span> A padded box, protective bags and a prepaid return ' +
      "label arrive in 2 to 3 days. $9.99 up to $250; $17.99 above $250.</span></span>" +
      '<span class="fmt-choice__p">' + money(kitOption().price) + "</span></button>" +
      '<button type="button" class="fmt-choice" data-log="drop" aria-pressed="' + (S.logistics === "drop") + '">' +
      '<span class="fmt-radio"></span><span class="fmt-choice__t">' +
      '<b>I\'ll drop it off locally</b>' +
      '<span class="fmt-choice__d"><span class="fmt-choice__fit">Best if you\'re nearby.</span> Six Twin Cities counters. Check opening hours before visiting.</span></span>' +
      '<span class="fmt-choice__p is-free">Free</span></button>' +
      '<button type="button" class="fmt-choice" data-log="ship" aria-pressed="' + (S.logistics === "ship") + '">' +
      '<span class="fmt-radio"></span><span class="fmt-choice__t">' +
      '<b>I\'ll ship it myself</b>' +
      '<span class="fmt-choice__d"><span class="fmt-choice__fit">Best if you have a box already.</span> We\'ll send the address and packing guidance right after checkout.</span></span>' +
      '<span class="fmt-choice__p is-free">Free</span></button></div>' +
      (S.logistics === "drop" && locs
        ? '<div class="fmt-drop__wrap"><label class="fmt-label">Which location?</label><div class="fmt-drop__list">' + locs + "</div></div>"
        : "") +
      "</div>";
  }

  function viewDeliveryChoices() {
    var rec = recommendedDrive();
    var h = contentHours();
    // Digital delivery is not one of the choices, it ships with every order.
    // Showing it as a radio meant picking a drive visually deselected it, which
    // read as "I am giving up the download".
    var included =
      '<div class="fmt-included">' +
      '<span class="fmt-included__tick">' +
      svg(ICONS.check, "") +
      "</span>" +
      "<span><b>Digital delivery, always included</b>" +
      '<span class="fmt-choice__d">Your files by private email download link.</span></span>' +
      '<span class="fmt-choice__p is-free">Included</span></div>';

    /* Two options, not seven: no drive, or the one that fits. Asking someone
       to choose between six capacities is asking them a question they have no
       way to answer -- they do not know what ninety minutes of VHS weighs --
       and now that the sizing is measured the shop can just answer it. */
    var need = driveNeed();
    var pick = need.drive;
    var noneOpt = CATALOG.drives[0];
    var qty = Math.max(1, parseInt(S.driveQty, 10) || 1);

    var rows =
      '<button type="button" class="fmt-choice" data-drive="' + esc(noneOpt.k) + '" aria-pressed="' +
      (String(S.drive) === String(noneOpt.k)) + '">' +
      '<span class="fmt-radio"></span><span class="fmt-choice__t"><b>' + esc(noneOpt.label) +
      "</b><span class=\"fmt-choice__d\">" + esc(noneOpt.note) + "</span></span>" +
      '<span class="fmt-choice__p is-free">Included</span></button>';

    var previous = driveObj();
    if (previous.vid && pick && String(previous.k) !== String(pick.k)) {
      rows += '<div class="fmt-cart-notice">Your current selection is ' + S.driveQty + ' × ' + esc(previous.label) + '. Your updated project is estimated at ' + gbLabel(need.need / 1.10) + '. Choose the recommended drive below or download only.</div>';
    }
    if (pick) {
      var picked = String(S.drive) === String(pick.k);
      var totalCap = driveCapacityGb(pick) * qty;
      var fits = totalCap >= need.need;
      rows +=
        '<button type="button" class="fmt-choice" data-drive="' + esc(pick.k) + '" aria-pressed="' +
        picked + '">' +
        '<span class="fmt-radio"></span><span class="fmt-choice__t"><b>' + esc(pick.label) + ' <span class="fmt-recommended">Recommended</span></b>' +
        '<span class="fmt-choice__d">' +
        (need.provisional ? "64GB backup option. We confirm capacity when your media arrives." : need.qty > 1
          /* One of these does NOT hold the order. Saying "with room to
             spare" here would be a flat untruth about a $240 line item,
             printed next to the sentence saying two are needed. */
          ? "Your files come to " + gbLabel(need.need / 1.10) + ", which is more than any " +
            "single drive we stock holds, so this is " + need.qty + " of them."
          // Says the same thing the badge did, in a sentence, where it can also
          // explain itself.
          : !need.need ? "Our smallest USB option. We confirm the final file size when your media arrives." : "Sized for your order, holds your " + gbLabel(need.need / 1.10) +
            " of finished files with room to spare.") +
        "</span></span>" +
        '<span class="fmt-choice__p">' + money(pick.price * qty) + "</span></button>";

      if (picked) {
        rows +=
          '<div class="fmt-driveqty">' +
          '<span class="fmt-driveqty__l"><b>How many drives?</b>' +
          '<span>' + (need.provisional ? 'We will confirm the capacity before starting work.' : need.qty > 1 ? need.qty + " drives are needed for the estimated file size." : "One drive fits the estimated file size. Add copies for family if you wish.") + '</span></span>' +
          '<span class="fmt-stepper">' +
          '<button type="button" data-driveqty="-" aria-label="One fewer drive">\u2212</button>' +
          '<input type="text" inputmode="numeric" value="' + qty + '" data-driveqty-in aria-label="Number of drives">' +
          '<button type="button" data-driveqty="+" aria-label="One more drive">+</button>' +
          "</span></div>" +
          (fits ? "" :
            '<p class="fmt-error" role="alert">' + need.qty +
            " of these is the minimum that will hold your files. Fewer and they will not all fit.</p>");
      }
    }

    return '<p class="fmt-step__eyebrow">' + stepLabel("back") + '</p>' +
      '<' + HL + ' class="fmt-step__h">How do you want to receive your digital files?</' + HL + '>' +
      '<div class="fmt-fields">' + included +
      '<div><p class="fmt-label">Add a USB drive?</p>' +
      '<div class="fmt-choices">' + rows + "</div></div>" +
      (!pick ? '<p class="fmt-cart-notice">USB copies are currently unavailable. Download delivery is included; call or text us to arrange a backup.</p>' : '') +
      '<details class="fmt-option-details"' + (discLines().length ? ' open' : '') + '><summary>Add DVD or CD copies <span>Optional</span></summary>' + discBlock() + '</details>' +
      (need.need
        ? '<p class="fmt-hint">Your files come to about <b>' + gbLabel(need.need / 1.10) +
          "</b>, which is how we sized this." +
          (h ? " That is roughly " + h.toFixed(1) + " hours of footage." : "") + "</p>"
        : "") +
      "</div>";
  }

  /* Condition and extras.
     Repair, inspection and editing existed as standalone products that almost
     nobody found. They belong here, at the one moment the customer is already
     thinking about the state of what they are about to hand over. Inspection is
     free and deliberately listed first: "I do not know" is the honest answer for
     most people, and charging for the answer would suppress the whole section. */
  function extraRow(key, label, note, unit, qty) {
    return '<div class="fmt-qrow"><span class="fmt-qrow__lbl"><b>' + esc(label) + "</b>" +
      "<span>" + esc(note) + (unit ? " · " + money(unit) + " each" : "") + "</span></span>" +
      '<span class="fmt-stepper">' +
      '<button type="button" data-xdec="' + key + '" aria-label="Fewer ' + esc(label) + '">&minus;</button>' +
      '<input type="number" min="0" inputmode="numeric" value="' + qty + '" data-xqty="' + key +
      '" aria-label="Number of ' + esc(label) + '">' +
      '<button type="button" data-xinc="' + key + '" aria-label="More ' + esc(label) + '">+</button>' +
      "</span>" +
      '<span class="fmt-qrow__amt">' + (qty ? money(unit * qty) : ", ") + "</span></div>";
  }

  function extrasBlock() {
    var x = CATALOG.extra;
    var rows = "";

    rows += '<button type="button" class="fmt-choice fmt-extras__inspect" data-inspect aria-pressed="' +
      S.inspectFirst + '">' +
      '<span class="fmt-radio"></span><span class="fmt-choice__t">' +
      "<b>Have us inspect it first</b><span class=\"fmt-choice__d\">You do not need to know what is broken. We check every item on " +
      "arrival, tell you what needs work, and you approve any repair before it happens.</span></span>" +
      '<span class="fmt-choice__p is-free">Free</span></button>';

    if (x.repair.price) {
      rows += extraRow("repair", "Items I know need repair",
        "Snapped tape, cracked shells, mould, repaired in-house before transfer",
        x.repair.price, S.repairQty);
    }
    if (x.editing.price) {
      rows += extraRow("editing", "Custom editing",
        "Combine reels into one watchable film, trim dead footage, add titles",
        x.editing.price, S.editingQty);
    }
    return '<div class="fmt-qblock fmt-extras"><div class="fmt-qhead">' +
      svg(ICONS.help, "fmt-qhead__ic") +
      '<span class="fmt-qhead__t">Condition &amp; extras</span></div>' +
      '<div class="fmt-qbody">' + rows +
      '<p class="fmt-hint">Your selected options are included in the amount you pay when ordering. We will contact you about any changes needed after reviewing your media.</p>' +
      "</div></div>";
  }

  /* Discs are quantities rather than a choice, four siblings, four copies, 
     so they get steppers alongside the drive radio rather than competing with
     it. Both come from the same "Add a Physical Backup" product. */
  function discBlock() {
    if (!CATALOG.discs || !CATALOG.discs.length) return "";
    var rows = CATALOG.discs.map(function (d) {
      var qty = S.discs[d.k] || 0;
      return '<div class="fmt-qrow"><span class="fmt-qrow__lbl"><b>' + esc(d.label) + "</b>" +
        "<span>" + esc(d.note) + " · " + money(d.price) + " each</span></span>" +
        '<span class="fmt-stepper">' +
        '<button type="button" data-ddec="' + esc(d.k) + '" aria-label="Fewer ' + esc(d.label) + '">&minus;</button>' +
        '<input type="number" min="0" inputmode="numeric" value="' + qty + '" data-dqty="' + esc(d.k) +
        '" aria-label="Number of ' + esc(d.label) + '">' +
        '<button type="button" data-dinc="' + esc(d.k) + '" aria-label="More ' + esc(d.label) + '">+</button>' +
        "</span>" +
        '<span class="fmt-qrow__amt">' + (qty ? money(d.price * qty) : ", ") + "</span></div>";
    }).join("");

    return '<div class="fmt-qblock"><div class="fmt-qhead">' +
      svg(ICONS.photo, "fmt-qhead__ic") +
      '<span class="fmt-qhead__t">Discs, add as many as you like</span></div>' +
      '<div class="fmt-qbody">' + rows +
      '<p class="fmt-hint">Separate from the drive above, you can have both. Useful for relatives ' +
      "who would rather put a disc in a player than open a link.</p></div></div>";
  }

  /* Was a condition quiz that opened by telling the customer they did not need
     to answer it. A question that answers itself is a step people click past,
     so what is left is the promise it was circling -- we look, we call you --
     plus somewhere to say the thing only they know. */
  function viewExtras() {
    return '<p class="fmt-step__eyebrow">' + stepLabel("extras") + "</p>" +
      "<" + HL + ' class="fmt-step__h">Anything we should know?</' + HL + ">" +
      '<div class="fmt-fields">' +
      '<div class="fmt-field"><label class="fmt-field__label" for="fmt-notes">Notes for the technician (optional)</label>' +
      '<textarea class="fmt-field__input fmt-field__textarea" id="fmt-notes" rows="4" data-notes ' +
      'placeholder="The wedding tape is the one in the white sleeve. The reels came from a damp basement.">' +
      esc(S.notes || "") + "</textarea></div>" +
      '<div class="fmt-note-promise">' +
      '<span class="fmt-note-promise__ic">' + svg(ICONS.check, "") + "</span>" +
      "<span><b>We inspect every item on arrival.</b> No extra repairs or charges without your approval.</span></div>" +
      "</div>";
  }

  /* Priced per photo with a count, not per order. A shoebox is 400 snapshots
     with six damaged portraits in it; charging restoration on all 400 turns a
     $120 upsell into a $8,000 estimate and loses the order. */
  function imageCount() {
    return lineItems().reduce(function (s, i) {
      return s + ((i.g.id === "photo" || i.g.id === "slide") ? i.q : 0);
    }, 0);
  }

  function fixVariant() { var c=CATALOG.imageFix||{};return S.fixLevel==='basic'?c.basicVariant:S.fixLevel==='full'?c.fullVariant:null; }
  function fixLevels() {
    var c = CATALOG.imageFix || {};
    return [
      { k: "none", label: "No correction", price: 0,
        note: "We scan them as they are, straightened, dust removed, nothing else." },
      { k: "basic", label: "Basic correction", price: c.basicVariant ? c.basicVariant.price / 100 : (c.basicPrice || 4.99),
        note: "Colour and contrast corrected, fading pulled back, scratches and creases cleaned up." },
      { k: "full", label: "Full restoration", price: c.fullVariant ? c.fullVariant.price / 100 : (c.fullPrice || 19.99),
        note: "Tears, water damage and missing pieces rebuilt by hand. For the few that matter most." }
    ];
  }

  function fixTotal() {
    var lv = fixLevels().filter(function (l) { return l.k === S.fixLevel; })[0];
    if (!lv || !lv.price) return 0;
    return lv.price * Math.max(0, parseInt(S.fixQty, 10) || 0);
  }

  function viewFix() {
    var c = CATALOG.imageFix || {};
    var max = imageCount();
    var qty = Math.max(0, Math.min(max, parseInt(S.fixQty, 10) || 0));

    var rows = fixLevels().map(function (l) {
      var on = S.fixLevel === l.k;
      var ex = (l.k === "basic" ? c.basicBefore : l.k === "full" ? c.fullBefore : "");
      var ea = (l.k === "basic" ? c.basicAfter : l.k === "full" ? c.fullAfter : "");
      return '<button type="button" class="fmt-choice" data-fix="' + esc(l.k) + '" aria-pressed="' + on + '">' +
        '<span class="fmt-radio"></span><span class="fmt-choice__t"><b>' + esc(l.label) + "</b>" +
        '<span class="fmt-choice__d">' + esc(l.note) + "</span>" +
        (ex && ea
          ? '<span class="fmt-ba">' +
            '<span class="fmt-ba__i"><img src="' + esc(ex) + '" alt="" loading="lazy"><em>Before</em></span>' +
            '<span class="fmt-ba__i"><img src="' + esc(ea) + '" alt="" loading="lazy"><em>After</em></span>' +
            "</span>"
          : "") +
        "</span>" +
        '<span class="fmt-choice__p' + (l.price ? "" : " is-free") + '">' +
        (l.price ? money(l.price) + " each" : "Included") + "</span></button>";
    }).join("");

    var counter = S.fixLevel && S.fixLevel !== "none"
      ? '<div class="fmt-driveqty">' +
        '<span class="fmt-driveqty__l"><b>How many of your ' + max + " need it?</b>" +
        "<span>Only the ones you pick. Not sure which? Say so in the notes and we will " +
        "help you choose. Your selected correction service is paid with this order.</span></span>" +
        '<span class="fmt-stepper">' +
        '<button type="button" data-fixqty="-" aria-label="One fewer">\u2212</button>' +
        '<input type="text" inputmode="numeric" value="' + qty + '" data-fixqty-in aria-label="How many photos">' +
        '<button type="button" data-fixqty="+" aria-label="One more">+</button>' +
        "</span></div>" +
        (qty ? '<p class="fmt-hint">' + qty + " \u00d7 " + money(fixLevels().filter(function (l) {
          return l.k === S.fixLevel; })[0].price) + " = <b>" + money(fixTotal()) + "</b></p>" : "")
      : "";

    var examples = '<div class="fmt-fix-examples">' + [
      {title:'Bring back color & contrast',image:c.basicComparison,alt:'Illustrative color correction: faded photo on the left, balanced color on the right'},
      {title:'Repair wear & damage',image:c.fullComparison,alt:'Illustrative restoration: creased portrait on the left, repaired portrait on the right'}
    ].filter(function(x){return x.image;}).map(function(x){return '<figure><figcaption>'+esc(x.title)+'</figcaption><img src="'+esc(x.image)+'" alt="'+esc(x.alt)+'" width="1200" height="600" loading="lazy"><div class="fmt-example-labels"><span>Before</span><span>After</span></div></figure>';}).join('') + '</div>';
    return '<p class="fmt-step__eyebrow">' + stepLabel("fix") + "</p>" +
      "<" + HL + ' class="fmt-step__h">Do any of your photos need work?</' + HL + ">" +
      '<p class="fmt-step__sub">Optional, and priced per photo, you pick how many. Every scan is ' +
      "straightened and dust-removed as standard, whichever you choose.</p>" + examples +
      '<p class="fmt-example-note">Illustrative examples, not completed customer projects. Results depend on the original. Your selected service and image count are included in the price shown.</p>' +
      '<div class="fmt-fields"><div class="fmt-choices">' + rows + "</div>" + counter + "</div>";
  }

  function viewWhen() {
    var rows = turnaroundSet().map(function (t) {
      return '<button type="button" class="fmt-choice" data-speed="' + esc(t.k) + '" aria-pressed="' +
        (S.speed === t.k) + '">' +
        '<span class="fmt-radio"></span><span class="fmt-choice__t"><b>' + esc(t.label) + "</b>" +
        '<span class="fmt-choice__d">' + esc(t.note) + "</span></span>" +
        '<span class="fmt-choice__p' + (t.price ? "" : " is-free") + '">' +
        (t.price ? money(t.price) : "Included") + "</span></button>";
    }).join("");

    return '<p class="fmt-step__eyebrow">' + stepLabel("when") + '</p>' +
      '<' + HL + ' class="fmt-step__h">When do you need it?</' + HL + '>' +
      '<div class="fmt-fields"><div class="fmt-choices">' + rows + "</div>" +
      '<label class="fmt-keep' + (S.keepOriginals ? "" : " is-off") + '">' +
      '<input type="checkbox" data-keep' + (S.keepOriginals ? " checked" : "") + ">" +
      "<span><b>Send my original tapes and photos back to me</b>" +
      "<span>On by default, and included in the price, originals always come home. " +
      "Untick only if you would rather not have them back; we hold them 30 days after your " +
      "files are delivered, then dispose of them securely.</span></span></label>" +
      '<p class="fmt-hint">Turnaround prices reflect your project size.</p></div>';
  }

  function subSection(html, title) {
    return html.replace(/<p class="fmt-step__eyebrow">[\s\S]*?<\/p>/, "")
      .replace(/<h[12] class="fmt-step__h">[\s\S]*?<\/h[12]>/, '<h2 class="fmt-h3">' + title + '</h2>');
  }
  function viewBack() {
    var timing = subSection(viewWhen(), 'Choose your turnaround');
    timing = timing.replace(/<label class="fmt-keep[\s\S]*?<\/label>/, '');
    return '<p class="fmt-step__eyebrow">' + stepLabel('back') + '</p><' + HL + ' class="fmt-step__h">Your timing. Your digital copies.</' + HL + '>' +
      '<section class="fmt-turnaround-panel"><p class="fmt-eyebrow">First, your timeline</p>' + timing + '</section>' +
      '<section class="fmt-delivery-panel">' + subSection(viewDeliveryChoices(), 'Keep a copy. Share a copy.') + '</section>' +
      '<label class="fmt-keep' + (S.keepOriginals ? '' : ' is-off') + '"><input type="checkbox" data-keep' + (S.keepOriginals ? ' checked' : '') + '><span><b>Return my originals</b><span>Included with your project. If you choose not to receive them, we hold them for 30 days after digital delivery before secure disposal.</span></span></label>';

  }
  function viewDone() {
    var t = totals(), drop = CATALOG.dropoffs.find(function (d) { return String(d.k) === String(S.dropoff); });
    var log = S.logistics === 'kit' ? 'Mail-in kit, ' + money(kitPrice()) : S.logistics === 'drop' ? (drop ? drop.label : 'Local drop-off') : 'Ship in your own box';
    var contents = t.items.map(function (i) { return i.q + ' × ' + esc(i.l.label); }).join('<br>');
    var imageOptions = hasImages() ? rsec('Photo correction', S.fixLevel === 'none' ? 'No correction added' : esc(fixLevels().find(function(l){return l.k===S.fixLevel;}).label) + ' · ' + S.fixQty + ' image(s) · ' + money(fixTotal()), stepIndex('fix')) : '';
    return '<p class="fmt-step__eyebrow">' + stepLabel('done') + '</p>' +
      '<h1 class="fmt-step__h">Ready to bring them back?</h1>' +
      '<p class="fmt-step__sub">Check your selections before checkout.</p>' +
      '<div class="fmt-review">' +
      rsec('Your media', contents || 'We will help identify your collection', stepIndex('many')) +
      rsec('Getting it here', esc(log), stepIndex('to')) +
      rsec('Digital files', 'Download included' + (driveObj().vid ? '<br>' + S.driveQty + ' × ' + esc(driveObj().label) : '') + discLines().map(function (x) { return '<br>' + x.qty + ' × ' + esc(x.d.label); }).join(''), stepIndex('back')) +
      rsec('Turnaround', esc(speedObj().label), stepIndex('back')) +
      rsec('Originals', S.keepOriginals ? 'Return my originals' : 'Do not return, hold 30 days after delivery, then dispose securely', stepIndex('back')) + '</div>' +
      imageOptions + '<div class="fmt-review-notes">' + subSection(viewExtras(), 'A note for your technician') + '</div>' +
      '<p class="fmt-save-device"><button type="button" class="fmt-link" data-goemail>Save your project by email</button></p>' +
      (S.error ? '<div class="fmt-error" role="alert" tabindex="-1">' + esc(S.error) + (priceReview ? '<p><a class="fmt-btn" href="' + (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart">Review cart and current price</a></p>' : '') + '</div>' : '') +
      '<div class="fmt-review-total"><span>Estimated project total</span><strong>' + money(t.total) + '</strong></div>' +
      '<p class="fmt-hint">Taxes and applicable shipping are calculated at checkout. We confirm any count or condition changes before starting work.</p>' +
      '<button type="button" class="fmt-btn fmt-btn--big" data-checkout>Continue to secure checkout <span aria-hidden="true"><svg class="fmt-arrow" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M4 12h16m-6-6 6 6-6 6"/></svg></span></button>' +
      (CATALOG.terms && CATALOG.terms.show ? '<p class="fmt-terms">' + CATALOG.terms.text + '</p>' : '') +
      '';
  }


  function rsec(k, v, goto) {
    return '<div class="fmt-rsec"><span class="fmt-rsec__k">' + esc(k) + "</span>" +
      '<span class="fmt-rsec__v">' + v + "</span>" +
      '<button type="button" class="fmt-edit" aria-label="Edit ' + esc(k) + '" data-goto="' + goto + '">Edit</button></div>';
  }

  function viewQuote() {
    return '<p class="fmt-step__eyebrow">Whole collections</p>' +
      '<' + HL + ' class="fmt-step__h">Let\'s price the whole thing at once</' + HL + '>' +
      '<p class="fmt-step__sub">A whole closet, an estate or a studio archive gets quoted as one project ' +
      "rather than per piece, it's almost always cheaper than the tiers, and we can work from a photo of the pile " +
      "instead of an exact count.</p>" +
      '<div class="fmt-fields"><div class="fmt-row2">' +
      '<div><label class="fmt-label" for="fmt-name">Your name</label>' +
      '<input type="text" id="fmt-name" autocomplete="name" value="' + esc(S.name) + '"></div>' +
      '<div><label class="fmt-label" for="fmt-email">Email</label>' +
      '<input type="email" id="fmt-email" autocomplete="email" value="' + esc(S.email) + '"></div></div>' +
      '<p class="fmt-hint">We\'ll come back within one business day with a flat price for the collection. If you can ' +
      "send a photo of everything stacked up, reply to our email with it, that's usually all we need.</p></div>";
  }

  /* ─── receipt ─────────────────────────────────────────────────────────── */
  function renderReceiptProgress() {
    var el = root.querySelector("[data-fmt-receipt-prog]");
    if (!el) return;
    var p = ladderProgress();
    if (!p || !p.v) { el.hidden = true; el.innerHTML = ""; return; }
    el.hidden = false;
    el.innerHTML = miniBar(p, "fmt-mini--wide") +
      '<span class="fmt-rprog__t">' +
      (p.pct ? "<b>" + p.pct + "% off</b> \u00b7 " + esc(p.label)
             : "<b>" + esc(p.label) + "</b>") +
      "</span>";
  }

  function renderReceipt() {
    renderReceiptProgress();
    var headTotal = root.querySelector("[data-fmt-receipt-total]");
    if (headTotal) {
      var ht = totals();
      headTotal.textContent = ht.total > 0 ? money(ht.total) : "";
    }
    var body = root.querySelector("[data-fmt-receipt-body]");
    if (!body) return;
    var t = totals();
    if (S.formats.indexOf('unsure') >= 0) {
      if (headTotal) headTotal.textContent = 'Quote';
      body.innerHTML = '<p class="fmt-receipt__empty"><b>We will help identify your media.</b><br>Send a description or photo of your collection. We will confirm the formats, quantities and price before work begins.</p>';
      return;
    }
    if (!t.items.length && !t.drive && !t.speed) {
      /* An empty panel apologising for being empty, in the most valuable
         space on the page, at the moment someone is deciding how much to
         send. The ladder is the one thing that answers that question -- and
         it is the argument for a bigger box, made before they have typed a
         single number. */
      var rungs = LADDER.map(function (r, i) {
        return '<li><span class="fmt-rung__at">' + money(r.min).replace(".00", "") + "+</span>" +
          '<span class="fmt-rung__off">' + r.pct + "% off</span></li>";
      }).join("");

      body.innerHTML = rungs
        ? '<div class="fmt-preview">' +
          "<p class=\"fmt-preview__t\"><b>The more you send, the less each piece costs.</b></p>" +
          '<ul class="fmt-rungs">' + rungs + "</ul>" +
          '<p class="fmt-preview__n">One rate for the whole order, tapes, photos, slides and film ' +
          "all count toward it together. Review your estimate before paying at checkout. The invoice may change if the actual media count differs.</p></div>"
        : '<p class="fmt-receipt__empty">Your estimate builds here as you go. Payment is collected ' +
          "when you place your order.</p>";
      return;
    }

    var h = t.items.map(function (i) {
      return '<div class="fmt-rline"><span class="fmt-rline__l"><b>' + esc(i.l.label) + "</b>" +
        "<span>" + i.q + " × " + money(i.unit) + "</span></span>" +
        '<span class="fmt-rline__v">' + money(i.sub) + "</span></div>";
    }).join("");

    if (t.drive) {
      var dq = Math.max(1, parseInt(S.driveQty, 10) || 1);
      h += '<div class="fmt-rline"><span class="fmt-rline__l"><b>' +
        (dq > 1 ? dq + " × " : "") + esc(driveObj().label) +
        '</b></span><span class="fmt-rline__v">' + money(t.drive) + "</span></div>";
    }
    if (t.fix) {
      var fl = fixLevels().filter(function (l) { return l.k === S.fixLevel; })[0];
      h += '<div class="fmt-rline"><span class="fmt-rline__l"><b>' +
        (S.fixQty > 1 ? S.fixQty + " \u00d7 " : "") + esc(fl ? fl.label : "Image correction") +
        '</b></span><span class="fmt-rline__v">' + money(t.fix) + "</span></div>";
    }
    if (t.speed) {
      h += '<div class="fmt-rline"><span class="fmt-rline__l"><b>' + esc(speedObj().label) +
        '</b></span><span class="fmt-rline__v">' + money(t.speed) + "</span></div>";
    }
    if (t.kit) {
      h += '<div class="fmt-rline"><span class="fmt-rline__l"><b>Mail-in kit</b>' +
        "<span>box, bags &amp; prepaid label</span></span>" +
        '<span class="fmt-rline__v">' + money(t.kit) + "</span></div>";
    }
    t.discs.forEach(function (x) {
      h += '<div class="fmt-rline"><span class="fmt-rline__l"><b>' + esc(x.d.label) + "</b>" +
        "<span>" + x.qty + " × " + money(x.d.price) + "</span></span>" +
        '<span class="fmt-rline__v">' + money(x.d.price * x.qty) + "</span></div>";
    });
    t.extras.forEach(function (e) {
      h += '<div class="fmt-rline"><span class="fmt-rline__l"><b>' + esc(e.label) + "</b>" +
        "<span>" + e.qty + " × " + money(e.unit) + "</span></span>" +
        '<span class="fmt-rline__v">' + money(e.unit * e.qty) + "</span></div>";
    });
    if (S.inspectFirst) {
      h += '<div class="fmt-rline"><span class="fmt-rline__l"><b>Inspection on arrival</b>' +
        "<span>we confirm before any repair</span></span>" +
        '<span class="fmt-rline__v">Free</span></div>';
    }
    if (t.saved > 0) {
      h += '<div class="fmt-rsave"><span>Volume savings</span><span>&minus;' + money(t.saved) + "</span></div>";
    }
    h += '<div class="fmt-rtot"><span class="fmt-rtot__l">Estimate</span>' +
      '<span class="fmt-rtot__v">' + money(t.total) + "</span></div>";

    /* Someone who skipped the email step is the person most worth reaching, and
       the least worth nagging. One quiet permanent line in the receipt rather
       than a second interruption: always available, never in the way. */
    if (!S.email) {
      h += '<button type="button" class="fmt-rmail" data-goemail>' +
        "✉ Add your email</button>";
    }
    body.innerHTML = h;
  }

  /* ─── cart ────────────────────────────────────────────────────────────── */
  function buildCartPayload() {
    var t = totals();
    var props = {};
    if (S.name) props["Name"] = S.name;
    if (S.logistics === "kit") props["Getting it to us"] = "Mail-in kit";
    if (S.logistics === "ship") props["Getting it to us"] = "Customer ships directly";
    if (S.logistics === "drop") {
      var lbl = "";
      CATALOG.dropoffs.forEach(function (d) { if (String(d.k) === String(S.dropoff)) lbl = d.label; });
      props["Getting it to us"] = "Drop off at " + lbl;
    }
    if (S.formats.indexOf("unsure") >= 0) {
      props["Note"] = "Customer is not sure what formats they have, identify and confirm before starting";
    }
    if (S.notes) props["Customer notes"] = S.notes;
    if (!S.keepOriginals) {
      props["Return originals"] = "NO, customer asked us not to return their media. Hold 30 days after delivery, then dispose securely.";
    }
    if (S.fixLevel && S.fixLevel !== "none" && S.fixQty > 0) {
      var fx = fixLevels().filter(function (l) { return l.k === S.fixLevel; })[0];
      props["Image correction"] = (fx ? fx.label : S.fixLevel) + " on " + S.fixQty + " image(s)";
    }
    if (S.inspectFirst) {
      props["Inspect first"] = "Yes, check condition on arrival and confirm any repair before doing it";
    }

    var items = t.items.filter(function (i) { return i.vid > 0; }).map(function (i) {
      var p = Object.assign({}, props);
      var q = qualityFor(i.g, i.l);
      if (q) p["Scan quality"] = q.label || (qualityFor(i.g) || {}).label;
      return { id: i.vid, quantity: i.q, properties: p };
    });

    /* Fulfilment marker: keeps the ops dashboard's existing drop-off reporting
       working, since it reads this $0 product rather than line item properties.

       Not added for a kit order once the real Mail-In Kit product exists. That
       product is the signal, and the marker variant still reads "I ordered a
       mail-in kit" -- a product that was retired -- which put a confusing
       $0 line in front of the customer at checkout. It stays as the fallback for
       a store where the kit product has not been created yet. */
    var fulfilVid = 0;
    if (S.logistics === "drop" && S.dropoff) fulfilVid = parseInt(S.dropoff, 10);
    else if (S.logistics === "kit" && !kitOption().vid) fulfilVid = CATALOG.fulfilment.kitVid;
    else if (S.logistics === "ship") fulfilVid = CATALOG.fulfilment.shipVid;
    if (fulfilVid) items.push({ id: fulfilVid, quantity: 1, properties: props });

    var d = driveObj();
    if (d && d.vid) {
      items.push({
        id: d.vid,
        quantity: Math.max(1, parseInt(S.driveQty, 10) || 1),
        properties: props
      });
    }

    var sp = speedObj();
    if (sp && sp.k !== "std" && sp.vid) items.push({ id: sp.vid, quantity: 1, properties: props });

    // Mail-in kit. Skipped if the product has not been created yet, the option
    // is still shown and the choice is still recorded on the line properties, so
    // ops sees the request even when there is nothing to charge for it.
    if (S.logistics === "kit" && kitOption().vid) {
      items.push({ id: kitOption().vid, quantity: 1, properties: props });
    }

    discLines().forEach(function (x) {
      if (!x.d.vid) return;
      items.push({ id: x.d.vid, quantity: x.qty, properties: props });
    });

    extrasLines().forEach(function (e) {
      if (!e.vid) return;
      var p = Object.assign({}, props);
      if (e.k === "repair" && S.inspectFirst) {
        p["Note"] = "Customer also asked us to inspect everything on arrival";
      }
      items.push({ id: e.vid, quantity: e.qty, properties: p });
    });

    if (hasImages() && S.fixLevel !== 'none' && S.fixQty > 0 && fixVariant()) {
      items.push({id:fixVariant().id,quantity:S.fixQty,properties:Object.assign({},props,{'Source images':'Images from this digitizing project'})});
    }
    return { items: items, expected: t.total };
  }

  // The cart service verifies the actual project lines and price before navigation.

  /* Assigning window.location inside the Shopify theme editor navigates the
     preview iframe rather than the tab, and the editor intercepts it, the
     visible result is the page jumping to the top and nothing else. Clicking a
     real anchor with target="_top" is treated as user-initiated top-level
     navigation, so it works in the editor, in a normal tab, and in any other
     framed preview. Outside a frame, _top behaves exactly like _self. */
  function isFramed() {
    try { return window.self !== window.top; } catch (e) { return true; }
  }

  function goToCheckout() {
    // Inside the Shopify theme editor the storefront runs in a sandboxed
    // iframe and top-level navigation out of it is blocked, which is why both
    // an anchor and a location assignment did nothing except appear to jump.
    // window.open from a user-initiated handler is not blocked, so a framed
    // context opens checkout in its own tab instead. Returns whether it managed
    // to do anything, so the caller can offer a link if the popup was blocked.
    if (isFramed()) {
      var w = window.open("/checkout", "_blank", "noopener");
      return !!w;
    }
    window.location.href = "/checkout";
    return true;
  }

  /* FMT recovery integration v2: explicit email request, acknowledged capture. */
  var recoveryConsent = false;
  var recoveryStorage = null;
  try { recoveryStorage = localStorage; } catch (_) {}
  var explicitRecoveryClient = window.FMTRecoveryClient ? window.FMTRecoveryClient.create({fetch:window.fetch.bind(window),siteId:'UKZx8S'}) : null;
  function createRecovery() { return window.FMTRecovery ? window.FMTRecovery.create({
    origin: window.location.origin,
    getClient: function () { return explicitRecoveryClient || window.klaviyo; },
    storage: recoveryStorage,
    restoredCapture: visit ? visit.getRecoveryContext() : null,
    onCaptureChange: function (context) { if (visit) visit.saveRecoveryContext(context); },
    getProject: function () { return { id: projectId, resumeUrl: resumeUrl(true), estimate: totals().total, stage: STEPS[S.step].key, formats: S.formats.slice() }; },
    onStatus: function (state) {
      var status = root.querySelector('[data-recovery-status]');
      if (status) { status.hidden = !state.message; status.textContent = state.message; }
    }
  }) : null; }
  var recovery = createRecovery();
  recoveryConsent = !!(recovery && recovery.getContext && recovery.getContext());

  function continueAfterRecovery() {
    S.error = ''; S.step = stepIndex('to'); S.reached = Math.max(S.reached, S.step);
    restored = false; render();
  }
  async function saveProgress(btn) {
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(S.email || '').trim())) {
      S.error = 'Enter your email address to save your project, or choose Continue without email.'; render();
      var emailField = root.querySelector('#fmt-email'); if (emailField) emailField.focus(); return;
    }
    if (!recoveryConsent) { S.error = 'Choose the email permission above to save your project, or skip this step.'; render(); return; }
    if (!recovery) { S.error = 'Email saving is temporarily unavailable. Your choices are still here. Try again later or continue without email.'; render(); return; }
    S.error = ''; var oldRecoveryError = root.querySelector('.fmt-error'); if (oldRecoveryError) oldRecoveryError.remove();
    btn.disabled = true; btn.textContent = 'Saving your project…';
    var outcome = await recovery.submit({ email: S.email, name: S.name, reminderConsent: true });
    if (outcome.status === 'saved') { continueAfterRecovery(); }
    else { btn.disabled = false; btn.textContent = 'Save email & continue'; }
  }

  var submitting = false;
  var acknowledgedCart = '';
  var priceReview = null;
  var restartPending = false;
  async function submitCart(btn) {
    if (submitting) return;
    normalizeSelection();
    for (var s = 0; s < STEPS.length - 1; s++) {
      if (!gateOk(s)) { S.step = s; S.error = whyBlocked(); render(); return; }
    }
    if (S.fixLevel !== 'none' && S.fixQty > 0 && (!fixVariant() || !fixVariant().available)) {
      S.error = 'This photo service is currently unavailable. Choose another service or call us for help.'; render(); return;
    }
    if (!lineItems().length || S.formats.indexOf('unsure') >= 0) { openEnquiry('quote'); return; }
    if (lineItems().some(function (i) { return !i.vid; }) || (S.logistics === 'kit' && !kitOption().vid) || (S.speed !== 'std' && !speedObj().vid)) {
      S.error = 'A selected service is currently unavailable online. Please review your selections or contact us to arrange this project.'; render(); return;
    }
    var payload = buildCartPayload(), requested = JSON.stringify(payload);
    if (!payload.items.length) { openEnquiry('quote'); return; }
    priceReview = null;
    submitting = true; btn.disabled = true; btn.textContent = 'Checking your project…';
    try {
      if (window.FMTCartVisit && !await window.FMTCartVisit.beforeCheckout()) {
        btn.disabled = false; btn.textContent = 'Open secure checkout'; return;
      }
      var result = await CORE.reconcile({ fetch: window.fetch.bind(window), root: window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/', items: payload.items, project: projectId, expectedCents: CORE.cents(payload.expected) });
      S.error = ''; persist();
      if (JSON.stringify(buildCartPayload()) !== requested) {
        btn.disabled = false; btn.textContent = 'Check updated project & continue'; return;
      }
      var otherSignature = JSON.stringify(result.cart ? result.cart.items.filter(function (i) { return !i.properties || i.properties._fmt_project !== projectId; }) : result.otherItemCount);
      if (result.otherItemCount && acknowledgedCart !== otherSignature) {
        acknowledgedCart = otherSignature;
        btn.textContent = 'Continue with this project and your cart';
        var notice = document.createElement('p'); notice.className = 'fmt-cart-notice'; notice.setAttribute('role', 'status');
        notice.textContent = 'Your existing cart contains ' + result.otherItemCount + ' other item(s). They have been kept and will also appear at checkout.';
        btn.before(notice);
        btn.disabled = false;
        return;
      }
      if (window.FMTKitCart) {
        var kitCheck=await window.FMTKitCart.ensure();
        if(kitCheck.changed){window.location.href='/cart';return;}
      }
      goToCheckout();
      btn.disabled = false; btn.textContent = 'Open secure checkout';
    } catch (error) {
      if (error.code === 'PRICE_MISMATCH' && Number.isSafeInteger(error.actualCents)) {
        priceReview = true;
        S.error = 'Shopify calculated ' + money(error.actualCents / 100) + ' for this project; your estimate was ' + money(error.expectedCents / 100) + '. Existing cart items or discounts may affect the price. Review your cart and its current prices before paying, or retry below. Your selections are saved.';
      } else S.error = error.message || 'We could not confirm your cart. Your selections are saved; please try again.';
      render();
      var alert = root.querySelector('.fmt-error'); if (alert) { alert.tabIndex = -1; alert.focus(); }
    } finally { submitting = false; }
  }

  /* ─── render & wiring ─────────────────────────────────────────────────── */
  /* Said in the second person and naming the thing that is missing, because
     "This field is required" is no help to someone who cannot see which one. */
  function whyBlocked() {
    var key = STEPS[S.step].key;
    if (key === "what") return "Pick at least one thing you would like digitized, tap any box above.";
    if (key === "many") return lineItems().some(function (i) { return !i.vid; }) ? "A selected service or scan quality is unavailable. Choose another option or contact us for help." : "Enter a quantity for each selected format, or choose I am not sure for help identifying your media.";
    if (key === "back") return "The selected USB capacity is too small for the estimated files. Choose the recommended drive or download only.";
    if (key === "to") {
      if (!S.logistics) return "Choose how you would like to get your media to us, tap one of the three above.";
      return "Choose which counter you would like to drop off at.";
    }
    if (key === 'fix') return !fixVariant() || !fixVariant().available ? 'This photo service is currently unavailable. Choose another service or call us for help.' : 'Choose how many photos need correction, or select No correction.';
    return "There is one more thing to choose on this step.";
  }

  /* What a given step needs before anything after it makes sense. Asked about
     any step, not just the current one, so the rail can work out which of the
     steps you have already visited are still safe to jump back into. */
  /* Prints, slides and negatives are the only things image correction applies
     to. Showing the step to someone sending twelve VHS tapes is a step they
     have to read and dismiss for no reason. */
  function hasImages() {
    return S.formats.indexOf("photo") >= 0 || S.formats.indexOf("slide") >= 0;
  }
  function stepSkipped(i) {
    return STEPS[i].key === "fix" && !hasImages();
  }

  /* Position and total among the steps this order actually has. A skipped step
     must not leave a hole in the count -- "5 of 9" followed by "7 of 9" reads
     as something having gone wrong. */
  function stepPos(i) {
    var n = 0;
    for (var j = 0; j <= i; j++) { if (!stepSkipped(j)) n++; }
    return n;
  }
  function stepTotal() {
    var n = 0;
    for (var j = 0; j < STEPS.length; j++) { if (!stepSkipped(j)) n++; }
    return n;
  }

  function gateOk(i) {
    var key = STEPS[i].key;
    if (key === 'fix') return !hasImages() || S.fixLevel === 'none' || (Number.isInteger(S.fixQty) && S.fixQty > 0 && S.fixQty <= imageCount() && !!fixVariant() && fixVariant().available);
    if (key === "what") return S.formats.length > 0;
    if (key === "many") return !lineItems().some(function (i) { return !i.vid; }) && (S.formats.indexOf('unsure') >= 0 || S.formats.every(function (id) { var g = group(id); return g && countIn(g) > 0; }));
    if (key === "back") return !driveObj().vid || (driveCapacityGb(driveObj()) * S.driveQty >= contentGb() * 1.10);
    if (key === "to") return !!S.logistics && (S.logistics !== "drop" || !!S.dropoff || !CATALOG.dropoffs.length);
    return true;
  }

  function canAdvance() {
    if (S.quoteMode) return true;
    return gateOk(S.step);
  }

  /* Backwards is always allowed. Forwards only to somewhere you have actually
     been, and only if everything it depends on still holds -- otherwise going
     back to step 1, clearing the formats and jumping forward would land you on
     a quantity step with nothing on it. */
  function canJumpTo(i) {
    if (i === S.step) return false;
    if (stepSkipped(i)) return false;
    if (i < S.step) return true;
    if (i > S.reached) return false;
    for (var g = 0; g < i; g++) { if (!gateOk(g)) return false; }
    return true;
  }

  // Phones hide the eight bubbles to save 87px, but going back should not mean
  // pressing Back four times. Tapping the compact line opens the same rail.
  var railOpen = false;

  /* The sticky receipt is fixed to the bottom, so the page has to reserve
     room or the last thing on it sits underneath. That reservation was a
     hardcoded 160px against a receipt that is 85px, leaving 75px of blank
     space above the footer -- and it went wrong in the other direction as soon
     as the receipt grew a discount line. Measured, so it is always exactly the
     clearance needed and exactly zero when the receipt is not fixed. */
  function syncReceiptClearance() {
    var inner = root.querySelector(".fmt-builder__inner");
    var rec = root.querySelector(".fmt-receipt");
    if (!inner) return;
    var fixed = rec && window.getComputedStyle(rec).position === "fixed";
    inner.style.setProperty("--fmt-receipt-clear",
      fixed ? Math.ceil(rec.getBoundingClientRect().height) + 12 + "px" : "0px");
  }

  window.addEventListener("resize", syncReceiptClearance);

  function renderRail() {
    var rail = root.querySelector("[data-fmt-rail]");
    if (!rail) return;
    rail.classList.toggle("is-revealed", railOpen);
    // Completed steps are buttons, so the rail works as navigation rather than
    // decoration, going back four steps should not mean pressing Back four
    // times. Steps ahead stay inert, since jumping forward would skip answers
    // the later steps depend on.
    /* A phone gets one line instead of eight wrapping bubbles: the same
       information, 76px less of it. The full rail stays on desktop, where it is
       real navigation rather than decoration. */
    var compact = root.querySelector("[data-fmt-rail-compact]");
    if (compact) {
      var pct = Math.round((stepPos(S.step) / stepTotal()) * 100);
      compact.innerHTML =
        '<button type="button" class="fmt-railc__btn" data-rail-toggle aria-expanded="' +
        (railOpen ? "true" : "false") + '" aria-controls="' + esc(rail.id || 'fmt-order-steps') + '" aria-label="' + (railOpen ? 'Hide' : 'Show') + ' all ' + stepTotal() + ' steps">' +
        '<span class="fmt-railc__t">Step ' + stepPos(S.step) + " of " + stepTotal() +
        ' \u00b7 <b>' + esc(STEPS[S.step].rail) + "</b></span>" +
        '<span class="fmt-railc__bar"><i style="width:' + pct + '%"></i></span>' +
        '<span class="fmt-railc__chev" aria-hidden="true"></span></button>';
      // Wired here, not in wire(): this innerHTML is rewritten on every toggle,
      // so a listener bound anywhere else is attached to a discarded button and
      // the picker opens once and then never closes.
      var tog = compact.querySelector("[data-rail-toggle]");
      if (tog) tog.addEventListener("click", function () {
        railOpen = !railOpen;
        renderRail();
        focusControl(compact.querySelector("[data-rail-toggle]"), true);
      });
    }

    /* A step that does not apply to this order must not appear in the rail. It
       was rendering "Photos" with a tick on an order containing no photos --
       claiming credit for a screen the customer never saw -- and putting nine
       entries under a counter that reads "of 8". */
    rail.innerHTML = STEPS.map(function (s, i) {
      if (stepSkipped(i)) return "";
      /* Completed means you have been past it, not that it is behind you right
         now. Going back to step 1 to check something should not un-answer the
         four steps you already filled in -- the answers are still there, and
         the ticks are what says so. */
      var done = i < S.reached && i !== S.step;
      var visited = i <= S.reached;
      var go = canJumpTo(i);
      var cls = done ? "is-done" : i === S.step ? "is-now" : visited ? "is-visited" : "";
      // stepPos, not the raw index: with a step hidden the dots were numbered
      // 5, 7, 8, 9 -- a visible gap where the customer is told there is none.
      var inner = '<span class="n">' + (done ? "✓" : stepPos(i)) + "</span>" + esc(s.rail);
      if (go) {
        return '<li class="' + cls + '">' +
          '<button type="button" class="fmt-rail__go" data-rail="' + i + '" ' +
          'aria-label="' + (i < S.step ? "Back to" : "Forward to") + " step " + stepPos(i) +
          ", " + esc(s.rail) + '">' + inner + "</button></li>";
      }
      return '<li class="' + cls + '"' + (i === S.step ? ' aria-current="step"' : "") + ">" + inner + "</li>";
    }).join("");

    Array.prototype.forEach.call(rail.querySelectorAll("[data-rail]"), function (b) {
      b.addEventListener("click", function () {
        // Jumping to a step from the revealed rail closes it again, so the
        // customer lands on the step rather than on the list of steps.
        railOpen = false;
        // Deliberate navigation means they have stopped arriving and started
        // working; the welcome-back notice has done its job.
        restored = false;
        S.step = parseInt(b.getAttribute("data-rail"), 10);
        S.quoteMode = false;
        render();
      });
    });
  }

  var VIEWS = {
    what: viewWhat, who: viewWho, many: viewMany, to: viewTo,
    back: viewBack, fix: viewFix, extras: viewExtras, when: viewWhen,
    done: viewDone, quote: viewQuote
  };

  /* Offered on every step, not just at the end. The moment someone stalls is
     the moment they leave, and in this business the recovery is a person, 
     the reviews name John unprompted. */
  /* Both routes to a person open the same dialog, prefilled from the builder.
     Sending someone to /pages/contact from step 3 of 8 abandons the order to
     ask a question about it. */
  function openEnquiry(kind) {
    var api = window.FMTEnquiry;
    if (!api || typeof api.open !== "function") {
      window.location.href = (root.dataset.quoteUrl || "/pages/contact");
      return;
    }
    var t = totals();
    // Only the formats with something in them. A quote request that opens
    // "Film reels: 0 reels" reads like a form the customer has to correct.
    var lines = S.formats.map(function (id) {
      var g = group(id);
      if (!g) return "";
      var n = countIn(g);
      if (!n) return "";
      return "\u2022 " + g.name + ": " + n + " " + g.unit + (n === 1 ? "" : "s");
    }).filter(Boolean);

    api.open({
      kind: kind,
      email: S.email || "",
      name: S.name || "",
      about: kind === "quote" ? "A whole collection or estate" : "",
      heading: kind === "quote" ? "Tell us what you have" : "Send us a question",
      intro: kind === "quote"
        ? "Give us a rough idea of the collection and we will price it as one job, usually the same day."
        : "We reply within one business day, usually sooner.",
      /* Deliberately NOT prefilled. Opening a form to find sentences already
         written in it reads as a mistake -- or worse, as though something was
         sent on your behalf. The summary still reaches John; it just travels
         as a hidden field rather than as words put in the customer's mouth. */
      summary: lines.length
        ? "What they have so far:\n" + lines.join("\n") +
          "\nRunning estimate: " + money(t.total)
        : ""
    });
  }

  function helpBlock() {
    var h = CATALOG.help || {};
    var name = h.name || "John";
    var phone = h.phone || "(612) 649-4707";
    var tel = phone.replace(/[^0-9]/g, "");
    /* One line rather than a card. It repeats on all eight steps, so every
       pixel it takes is paid for eight times, and "Stuck? Call John" carries
       the whole offer without the explanatory sentence underneath. */
    /* On the quantity step this bar carries the large-collection route as
       well, because that prompt used to be a second block saying the same
       thing a few pixels higher. Anywhere else it is the plain Stuck? bar. */
    var counting = STEPS[S.step].key === "many";
    var lead = counting
      /* Deliberately not a number. A count treats a photograph and a VHS tape
         as the same unit, and the customer this bar most needs to reach is the
         one who does not want to count at all. */
      ? "<b>More than you want to count?</b><span class=\"fmt-help__long\">" +
        "</span>"
      : "<b>Stuck?</b><span class=\"fmt-help__long\"> " + esc(name) +
        " can talk you through it or price it over the phone.</span>";

    return '<div class="fmt-help">' +
      '<span class="fmt-help__ic">' + svg(ICONS.help, "") + "</span>" +
      '<span class="fmt-help__t">' + lead + "</span>" +
      '<span class="fmt-help__actions">' +
      '<a class="fmt-btn fmt-btn--quiet fmt-help__btn" href="tel:' + tel + '">Call' +
      '<span class="fmt-help__numlong"> ' + esc(phone) + "</span></a>" +
      (counting
        ? '<button type="button" class="fmt-btn fmt-btn--quiet fmt-help__btn" data-go-quote>Get a quote</button>'
        : '<button type="button" class="fmt-btn fmt-btn--quiet fmt-help__btn" data-go-message>Message</button>') +
      "</span></div>";
  }

  /* Advancing a step used to leave the viewport exactly where the Continue
     button was, so the next step opened already scrolled past its own heading.
     Scrolls to the top of the builder rather than the step card, because the
     progress rail sits above the card and both belong in view. Skipped on the
     first paint so simply landing on the page does not yank it. */
  var painted = false;
  var lastView = null;
  function scrollToStep() {
    var view = S.quoteMode ? "quote" : STEPS[S.step].key;
    // render() also runs on every in-step interaction, picking a tile, a drive,
    // a radio. Scrolling on those yanked the page to the top on every click.
    if (view === lastView) return;
    lastView = view;
    if (!painted) { painted = true; return; }

    /* Instant, not smooth. The step's markup is replaced in the same tick, and
       a height change cancels an in-flight smooth scroll, which is why this
       kept landing partway down, far enough to clip the step rail.

       Reasserted across the next two frames because scroll anchoring exists to
       restore your position when content above you resizes, and a whole step
       being swapped out is exactly the case it acts on. By the second frame
       layout has settled and nothing moves it again. */
    function toTop() {
      // Explicit instant movement also respects reduced-motion preferences when
      // the surrounding theme enables smooth scrolling.
      try { window.scrollTo({ top: 0, left: 0, behavior: 'instant' }); }
      catch (_) { window.scrollTo(0, 0); }
    }
    toTop();
    if (typeof requestAnimationFrame === "function") {
      requestAnimationFrame(function () {
        toTop();
        requestAnimationFrame(toTop);
      });
    } else {
      setTimeout(toTop, 0);
    }
  }

  /* FMT builder usability v1: focus and semantics without altering order data. */
  var FOCUS_ATTRIBUTES = ['data-fmt', 'data-qty', 'data-inc', 'data-dec', 'data-qual', 'data-gtoggle', 'data-log', 'data-drop', 'data-drive', 'data-driveqty', 'data-driveqty-in', 'data-dqty', 'data-dinc', 'data-ddec', 'data-xqty', 'data-xinc', 'data-xdec', 'data-inspect', 'data-optin', 'data-speed', 'data-keep', 'data-notes', 'data-fix', 'data-fixqty', 'data-fixqty-in', 'data-recovery-consent', 'data-copy-project', 'data-project-link', 'data-next', 'data-back', 'data-skip', 'data-rail-toggle', 'data-rail', 'data-goto', 'data-goemail', 'data-go-message', 'data-go-quote', 'data-restart'];
  function focusControl(control, preventScroll) {
    if (!control || !control.focus) return;
    try { control.focus({ preventScroll: !!preventScroll }); } catch (_) { control.focus(); }
  }
  function rememberFocus() {
    var active = document.activeElement;
    if (!active || !root.contains || !root.contains(active) || !active.getAttribute) return null;
    var descriptor = active.id ? { id: active.id } : null;
    if (!descriptor) FOCUS_ATTRIBUTES.some(function (name) {
      var value = active.getAttribute(name);
      if (value === null) return false;
      descriptor = { name: name, value: value }; return true;
    });
    if (descriptor) {
      try { descriptor.start = active.selectionStart; descriptor.end = active.selectionEnd; } catch (_) {}
    }
    return descriptor;
  }
  function restoreFocus(descriptor) {
    if (!descriptor) return;
    var control = null;
    Array.prototype.some.call(root.querySelectorAll(descriptor.id ? '[id]' : '[' + descriptor.name + ']'), function (candidate) {
      if (descriptor.id ? candidate.id === descriptor.id : candidate.getAttribute(descriptor.name) === descriptor.value) { control = candidate; return true; }
      return false;
    });
    focusControl(control, true);
    if (control && control.setSelectionRange && typeof descriptor.start === 'number') {
      try { control.setSelectionRange(descriptor.start, descriptor.end); } catch (_) {}
    }
  }
  function describeWith(control, id) {
    if (!control || !control.setAttribute) return;
    var ids = (control.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
    if (ids.indexOf(id) < 0) ids.push(id);
    control.setAttribute('aria-describedby', ids.join(' '));
  }
  function missingQuantityGroup() {
    return S.formats.filter(function (id) { var g = group(id); return g && countIn(g) === 0; })[0];
  }
  function revealMissingQuantity() {
    if (S.error && STEPS[S.step].key === 'many') {
      var missing = missingQuantityGroup();
      if (missing) S.openGroups[missing] = true;
    }
  }
  function describeStep(el, key) {
    var prefix = root.id || 'fmt-builder';
    var heading = el.querySelector('.fmt-step__h');
    var eyebrow = el.querySelector('.fmt-step__eyebrow');
    if (heading) {
      heading.id = prefix + '-heading'; heading.tabIndex = -1;
      if (el.setAttribute) el.setAttribute('aria-labelledby', heading.id);
    }
    if (eyebrow) {
      eyebrow.id = prefix + '-position';
      if (heading && heading.setAttribute) heading.setAttribute('aria-describedby', eyebrow.id);
    }
    var back = el.querySelector('[data-back]');
    var previousStep = S.step - 1; while (previousStep > 0 && stepSkipped(previousStep)) previousStep--;
    if (back) back.textContent = S.quoteMode ? 'Back to your project' : 'Back: ' + STEPS[Math.max(0, previousStep)].rail;
    var next = el.querySelector('[data-next]');
    if (next && key !== 'who' && key !== 'quote' && S.formats.indexOf('unsure') < 0) {
      var nextStep = S.step + 1; while (nextStep < STEPS.length - 1 && stepSkipped(nextStep)) nextStep++;
      next.textContent = key === 'fix' && S.fixLevel === 'none' ? 'Skip correction & review' : 'Next: ' + STEPS[Math.min(STEPS.length - 1, nextStep)].rail;
    }
    Array.prototype.forEach.call(el.querySelectorAll('[data-qty]'), function (input) {
      input.setAttribute('step', '1');
      describeWith(input, 'fmt-quantity-help');
      var row = input.closest && input.closest('.fmt-qrow');
      var note = row && row.querySelector('.fmt-qrow__lbl');
      if (note) { note.id = prefix + '-quantity-' + input.getAttribute('data-qty').replace(/[^a-z0-9_-]/gi, '-'); describeWith(input, note.id); }
    });
    Array.prototype.forEach.call(el.querySelectorAll('[data-gtoggle]'), function (button) {
      var block = button.closest && button.closest('.fmt-qblock');
      var body = block && block.querySelector('.fmt-qbody');
      if (body) { body.id = prefix + '-group-' + button.getAttribute('data-gtoggle'); button.setAttribute('aria-controls', body.id); }
    });
    var error = el.querySelector('.fmt-error');
    if (error) { error.id = prefix + '-error'; error.tabIndex = -1; }
    var status = root.querySelector('[data-fmt-status]');
    if (status && !S.error && key === priorView) {
      var estimate = 'Estimated project total: ' + money(totals().total) + '.';
      if (status.textContent !== estimate) status.textContent = estimate;
    } else if (status) status.textContent = '';
  }
  function focusStepError(el, key) {
    var error = el.querySelector('.fmt-error');
    if (!error) return;
    var target = null;
    if (key === 'who' && /Enter your email/.test(S.error)) target = el.querySelector('#fmt-email');
    else if (key === 'who' && /email permission/.test(S.error)) target = el.querySelector('[data-recovery-consent]');
    else if (key === 'many') {
      var missing = missingQuantityGroup();
      if (missing) Array.prototype.some.call(el.querySelectorAll('[data-qty]'), function (input) {
        if (input.getAttribute('data-qty').split(':')[0] === missing) { target = input; return true; } return false;
      });
    } else if (key === 'what') target = el.querySelector('[data-fmt]');
    else if (key === 'to') target = el.querySelector(S.logistics ? '[data-drop]' : '[data-log]');
    else if (key === 'back') target = el.querySelector('[data-drive]');
    if (target) { describeWith(target, error.id); target.setAttribute('aria-invalid', 'true'); }
    focusControl(target || error, false);
  }

  var priorStep = -1;
  var priorView = null;
  function render() {
    var previousFocus = rememberFocus();
    normalizeSelection();
    revealMissingQuantity();
    renderRail();
    var el = root.querySelector("[data-fmt-step]");
    if (stepSkipped(S.step)) S.step = stepIndex("done");
    var key = S.quoteMode ? "quote" : STEPS[S.step].key;
    root.dataset.currentStep = key;
    /* Silence was the bug here. The builder restored an order from three days
       ago straight onto step 5 with nothing said, which for someone who does
       not remember starting it reads as a website that has lost its place. It
       also gives them the way out that did not exist.

       First thing in the step, so it sits directly under the step indicator
       and above the heading. That order matters: the rail says "Step 5 of 8"
       and this explains why, so it reads as a caption to the progress rather
       than an interruption before it -- and the indicator stays anchored at
       the top, which is what orients someone who has been away. */
    var notice = "";
    if (restored) {
      notice = '<div class="fmt-resume" role="status"><div class="fmt-resume__msg">' +
        "<p><b>Welcome back, your project is ready to continue.</b> You were on step " +
        stepPos(restoredStep) + " of " + stepTotal() + ", and this saved link does not place or pay for an order. " +
        "</p>" +
        (S.error ? '<p class="fmt-error" role="alert">' + esc(S.error) + '</p>' : '') + (restartPending ? '<p class="fmt-resume__warn">This clears your cart and saved selections in this tab. Placed orders are not affected.</p>' : '') + '</div><div class="fmt-resume__actions">' + '<button type="button" class="fmt-btn fmt-btn--quiet" data-restart>' + (restartPending ? 'Clear cart and start over' : 'Start a new project') + '</button>' + (restartPending ? '<button type="button" class="fmt-link" data-cancel-restart>Keep this project</button>' : '') + '</div>' +
        "</div>";
    }

    var html = notice + VIEWS[key]();

    if (key !== "done") {
      /* Above the nav, so the answer appears where the question was asked.
         role=alert so it is announced rather than only seen. */
      html += (S.error && key !== "done"
        ? '<p class="fmt-error" role="alert">' + esc(S.error) + "</p>"
        : "");
      html += '<div class="fmt-nav">' +
        (S.step > 0 || S.quoteMode ? '<button type="button" class="fmt-btn fmt-btn--ghost" data-back>Back</button>' : "") +
        '<span class="fmt-btn--spacer"></span>' +
        // Beside Continue rather than off next to Back: this step never blocked
        // anything, and a skip hidden at the far left reads like a trapdoor
        // rather than an option.
        (key === "who" ? '<button type="button" class="fmt-btn fmt-btn--ghost fmt-skip" data-skip>Continue without email</button>' : "") +
        /* Deliberately not disabled. A greyed-out Continue gives no reason
           and no feedback -- you press it, nothing happens, and you are left to
           work out what you missed. Live, it can answer. */
        '<button type="button" class="fmt-btn" data-next' +
        "" + ">" +
        (S.formats.indexOf("unsure") >= 0 ? "Get help identifying my media" : S.quoteMode ? "Send my request" : key === "who" ? "Save email & continue" : "Continue") + "</button></div>";
    } else {
      html += '<div class="fmt-nav"><button type="button" class="fmt-btn fmt-btn--ghost" data-back>Back</button></div>';
    }

    var intro = root.querySelector("[data-fmt-intro]");
    if (intro) intro.hidden = S.step > 0 || S.quoteMode;

    /* After the step, not before it. This is what someone reaches for once the
       step has already defeated them, and at the top it cost every customer
       146px above the heading on every one of the eight screens -- which was
       the difference between seeing Continue and having to hunt for it. */
    el.innerHTML = html.replace('<div class="fmt-nav">', helpBlock() + '<div class="fmt-nav">');
    renderReceipt();
    describeStep(el, key);
    wire(el);
    persist();
    syncReceiptClearance();
    var changedView = priorView !== key;
    if (changedView) {
      scrollToStep();
      if (priorView !== null && !S.error) focusControl(el.querySelector('.fmt-step__h'), true);
    }
    if (S.error) focusStepError(el, key);
    else if (!changedView) restoreFocus(previousFocus);
    if (priorStep !== S.step) {
      // Public funnel signal contains only the current step, never project data.
      if (typeof window.CustomEvent === 'function' && typeof window.dispatchEvent === 'function') {
        window.dispatchEvent(new window.CustomEvent('fmt:builder-step', { detail: { step: STEPS[S.step].key, number: S.step + 1 } }));
      }
      priorStep = S.step;
    }
    priorView = key;
  }

  function wire(el) {
    function on(sel, fn) {
      Array.prototype.forEach.call(el.querySelectorAll(sel), function (b) {
        b.addEventListener("click", function () { S.error = ""; fn(b); render(); });
      });
    }

    // Any choice may have resolved what the message was complaining about.
    on("[data-fmt], [data-log], [data-drop]", function () { S.error = ""; });

    on("[data-fmt]", function (b) {
      var id = b.getAttribute("data-fmt");
      var i = S.formats.indexOf(id);
      if (i >= 0) S.formats.splice(i, 1); else S.formats.push(id);
      // "Not sure" is mutually exclusive with picking specific formats.
      if (id === "unsure" && S.formats.indexOf("unsure") >= 0) S.formats = ["unsure"];
      else if (S.formats.indexOf("unsure") >= 0 && S.formats.length > 1) {
        S.formats = S.formats.filter(function (x) { return x !== "unsure"; });
      }
    });

    on("[data-log]", function (b) {
      S.logistics = b.getAttribute("data-log");
      if (S.logistics !== "drop") S.dropoff = null;
    });
    on("[data-drop]", function (b) { S.dropoff = b.getAttribute("data-drop"); });
    on("[data-drive]", function (b) {
      S.drive = b.getAttribute("data-drive");
      // Choosing the drive resets to the number actually needed, so someone who
      // set 3 then removed half their order is not left buying three.
      if (S.drive !== "none") S.driveQty = driveNeed().qty;
    });
    on("[data-fix]", function (b) {
      S.fixLevel = b.getAttribute("data-fix");
      // Default to one rather than zero: picking a level and being charged
      // nothing reads as the choice not having registered.
      if (S.fixLevel !== "none" && !S.fixQty) S.fixQty = 1;
      if (S.fixLevel === "none") S.fixQty = 0;
    });
    on("[data-fixqty]", function (b) {
      var d = b.getAttribute("data-fixqty") === "+" ? 1 : -1;
      S.fixQty = Math.max(0, Math.min(imageCount(), (parseInt(S.fixQty, 10) || 0) + d));
    });
    var fq = el.querySelector("[data-fixqty-in]");
    if (fq) fq.addEventListener("change", function () {
      S.fixQty = Math.max(0, Math.min(imageCount(), parseInt(fq.value, 10) || 0));
      render();
    });

    var nt = el.querySelector("[data-notes]");
    if (nt) nt.addEventListener("input", function () { S.notes = nt.value; persist(); });

    /* The one irreversible choice in the builder, so it confirms. Everything
       else here can be undone by going back a step; this one ends with media
       being destroyed, and the whole site promises the opposite. */
    var ko = el.querySelector("[data-keep]");
    if (ko) ko.addEventListener("change", function () {
      if (!ko.checked) {
        var ok = window.confirm(
          "Just to be sure, you do NOT want your original tapes and photos back?\n\n" +
          "We will hold them for 30 days after your files are delivered, then dispose of them " +
          "securely. This cannot be undone once that period passes."
        );
        if (!ok) { ko.checked = true; S.keepOriginals = true; render(); return; }
      }
      S.keepOriginals = ko.checked;
      render();
    });

    on("[data-driveqty]", function (b) {
      var d = b.getAttribute("data-driveqty") === "+" ? 1 : -1;
      S.driveQty = Math.max(1, Math.min(20, (parseInt(S.driveQty, 10) || 1) + d));
    });
    var dq = el.querySelector("[data-driveqty-in]");
    if (dq) dq.addEventListener("change", function () {
      S.driveQty = Math.max(1, Math.min(20, parseInt(dq.value, 10) || 1));
      render();
    });
    on("[data-speed]", function (b) { S.speed = b.getAttribute("data-speed"); });
    on("[data-qual]", function (b) {
      var parts = b.getAttribute("data-qual").split(":");
      S.quality[parts[0]] = parts[1];
    });
    on("[data-goto]", function (b) { S.step = Math.min(STEPS.length - 1, CORE.count(b.getAttribute("data-goto"))); S.quoteMode = false; });
    on("[data-inspect]", function () { S.inspectFirst = !S.inspectFirst; });
    on("[data-gtoggle]", function (b) {
      // Read the state off the element rather than off the store: the store
      // holds "no preference yet", which is not the same as "closed".
      var blk = b.parentNode;
      S.openGroups[b.getAttribute("data-gtoggle")] =
        !(blk && blk.classList.contains("is-open"));
    });

    Array.prototype.forEach.call(el.querySelectorAll("[data-optin]"), function (cb) {
      cb.addEventListener("change", function () { S.marketing = cb.checked; persist(); });
    });
    on("[data-dinc]", function (b) {
      var k = b.getAttribute("data-dinc");
      S.discs[k] = (S.discs[k] || 0) + 1;
    });
    on("[data-ddec]", function (b) {
      var k = b.getAttribute("data-ddec");
      S.discs[k] = Math.max(0, (S.discs[k] || 0) - 1);
    });

    var XKEY = { repair: "repairQty", editing: "editingQty" };
    on("[data-xinc]", function (b) {
      var k = XKEY[b.getAttribute("data-xinc")];
      if (k) S[k] = (S[k] || 0) + 1;
    });
    on("[data-xdec]", function (b) {
      var k = XKEY[b.getAttribute("data-xdec")];
      if (k) S[k] = Math.max(0, (S[k] || 0) - 1);
    });
    on("[data-inc]", function (b) {
      var k = b.getAttribute("data-inc");
      S.qty[k] = (S.qty[k] || 0) + 1;
    });
    on("[data-dec]", function (b) {
      var k = b.getAttribute("data-dec");
      S.qty[k] = Math.max(0, (S.qty[k] || 0) - 1);
    });

    // Typing a quantity re-renders only the affected block, so the field keeps
    // focus and the caret doesn't jump mid-number.
    Array.prototype.forEach.call(el.querySelectorAll("[data-qty]"), function (inp) {
      inp.addEventListener("input", function () {
        var key = inp.getAttribute("data-qty");
        S.qty[key] = Math.max(0, parseInt(inp.value, 10) || 0);
        // The rate is now order-wide, so typing 40 into the tape box reprices
        // the photo rows too. Every block gets refreshed, not just this one.
        var pct = discountPct();
        var meter = el.querySelector(".fmt-tier");
        if (meter) meter.outerHTML = valueMeter();

        Array.prototype.forEach.call(el.querySelectorAll("[data-group]"), function (block) {
          var bg = group(block.getAttribute("data-group"));
          if (!bg) return;
          var rate = bg.tiered ? pct : 0;
          var prog = block.querySelector("[data-prog]");
          if (prog) prog.innerHTML = headProgress(bg);
          Array.prototype.forEach.call(block.querySelectorAll(".fmt-qrow"), function (row) {
            var f = row.querySelector("[data-qty]");
            var amt = row.querySelector(".fmt-qrow__amt");
            if (!f || !amt) return;
            var lk = f.getAttribute("data-qty").split(":")[1];
            var line = bg.lines.filter(function (l) { return l.k === lk; })[0];
            if (!line) return;
            var qv = S.qty[f.getAttribute("data-qty")] || 0;
            var list = listPrice(bg, line);
            var eff = line.noTier ? list : discountedUnit(list, rate);
            amt.innerHTML = money(eff * qv);
          });
        });
        renderReceipt();
        persist();
      });
    });

    Array.prototype.forEach.call(el.querySelectorAll("[data-dqty]"), function (inp) {
      inp.addEventListener("input", function () {
        var k = inp.getAttribute("data-dqty");
        S.discs[k] = Math.max(0, parseInt(inp.value, 10) || 0);
        var d = (CATALOG.discs || []).filter(function (x) { return x.k === k; })[0];
        var amt = inp.closest(".fmt-qrow").querySelector(".fmt-qrow__amt");
        if (amt && d) amt.innerHTML = S.discs[k] ? money(d.price * S.discs[k]) : ", ";
        renderReceipt();
        persist();
      });
    });

    Array.prototype.forEach.call(el.querySelectorAll("[data-xqty]"), function (inp) {
      inp.addEventListener("input", function () {
        var map = { repair: "repairQty", editing: "editingQty" };
        var k = map[inp.getAttribute("data-xqty")];
        if (!k) return;
        S[k] = Math.max(0, parseInt(inp.value, 10) || 0);
        var amt = inp.closest(".fmt-qrow").querySelector(".fmt-qrow__amt");
        var unit = { repairQty: CATALOG.extra.repair.price,
                     editingQty: CATALOG.extra.editing.price }[k] || 0;
        if (amt) amt.innerHTML = S[k] ? money(unit * S[k]) : ", ";
        renderReceipt();
        persist();
      });
    });

    var nameEl = el.querySelector("#fmt-name");
    var mailEl = el.querySelector("#fmt-email");
    if (nameEl) nameEl.addEventListener("input", function () { if (recovery) recovery.clear(); S.name = nameEl.value; persist(); });
    if (mailEl) mailEl.addEventListener("input", function () { if (recovery) recovery.clear(); S.email = mailEl.value; persist(); });
    var permission = el.querySelector('[data-recovery-consent]');
    if (permission) permission.addEventListener('change', function () { recoveryConsent = permission.checked; S.error = ''; var oldError = el.querySelector('.fmt-error'); if (oldError) oldError.remove(); if (!recoveryConsent && recovery) { if (recovery.withdraw) recovery.withdraw(); else recovery.clear(); } });

    var next = el.querySelector("[data-next]");
    if (next) next.addEventListener("click", function () {
      if (STEPS[S.step].key === "who") { saveProgress(next); return; }
      if (S.formats.indexOf('unsure') >= 0) { openEnquiry('quote'); return; }
      // Say what is missing and put it on screen, rather than doing nothing.
      if (!canAdvance()) {
        S.error = whyBlocked();
        render();
        // render() focuses and describes the specific missing answer.
        return;
      }
      S.error = "";
      if (S.quoteMode) {
        var qs = "?" + new URLSearchParams({
          subject: "Whole collection quote",
          name: S.name || "",
          email: S.email || ""
        }).toString();
        window.location.href = (root.dataset.quoteUrl || "/pages/contact") + qs;
        return;
      }
      // Contact and marketing choices are handled by Shopify checkout.
      if (S.step < STEPS.length - 1) {
        S.step++;
        // Step over the photo step when there are no photos, rather than
        // showing a screen whose only content is "this does not apply to you".
        while (S.step < STEPS.length - 1 && stepSkipped(S.step)) S.step++;
        if (S.step > S.reached) S.reached = S.step;
        restored = false;
        render();
      }
    });

    var restart = el.querySelector("[data-restart]");
    if (restart) restart.addEventListener("click", function () {
      if (!restartPending) { restartPending = true; render(); focusControl(root.querySelector('[data-restart]'), false); return; }
      resetVisit();
    });

    var cancelRestart = el.querySelector('[data-cancel-restart]');
    if (cancelRestart) cancelRestart.addEventListener('click', function(){restartPending=false;render();focusControl(root.querySelector('[data-restart]'),false);});
    var back = el.querySelector("[data-back]");
    if (back) back.addEventListener("click", function () {
      restored = false;
      if (S.quoteMode) S.quoteMode = false;
      else if (S.step > 0) {
        S.step--;
        while (S.step > 0 && stepSkipped(S.step)) S.step--;
      }
      render();
    });

    Array.prototype.forEach.call(root.querySelectorAll("[data-goemail]"), function (b) {
      b.addEventListener("click", function () {
        S.step = stepIndex("who");
        render();
      });
    });

    var skip = el.querySelector("[data-skip]");
    if (skip) skip.addEventListener("click", function () {
      if (recovery) recovery.clear(); recoveryConsent = false; S.error = ""; S.email = ""; S.name = ""; S.step++;
      /* Skipping still passes the step. Without this, "reached" stayed behind:
         the rail showed Estimate as pending after you had gone past it, and
         refused to let you jump forward across it later. */
      if (S.step > S.reached) S.reached = S.step;
      restored = false;
      render();
    });

    /* Was a separate builder step, which meant losing the half-built order to
       reach it. A dialog keeps the order on screen behind it, and carries what
       has been chosen so far into the message rather than asking twice. */
    Array.prototype.forEach.call(root.querySelectorAll("[data-go-quote]"), function (b) {
      b.addEventListener("click", function () { openEnquiry("quote"); });
    });

    Array.prototype.forEach.call(root.querySelectorAll("[data-go-message]"), function (b) {
      b.addEventListener("click", function () { openEnquiry("message"); });
    });

    var checkout = el.querySelector("[data-checkout]");
    if (checkout) checkout.addEventListener("click", function () { submitCart(checkout); });
  }

  // Close only the disclosure containing focus, without moving someone who is
  // working elsewhere in the form.
  if (root.addEventListener) root.addEventListener('keydown', function (event) {
    var rail = root.querySelector('[data-fmt-rail]');
    var compact = root.querySelector('[data-fmt-rail-compact]');
    var active = document.activeElement;
    if (event.key === 'Escape' && railOpen && ((rail && rail.contains(active)) || (compact && compact.contains(active)))) {
      event.preventDefault(); railOpen = false; renderRail();
      focusControl(compact && compact.querySelector('[data-rail-toggle]'), true);
    }
  });

  /* mobile receipt drawer */
  var head = root.querySelector("[data-fmt-receipt-head]");
  var receipt = root.querySelector("[data-fmt-receipt]");
  var toggle = root.querySelector("[data-fmt-receipt-toggle]");
  if (head && receipt) {
    var mobileReceipt = window.matchMedia('(max-width: 989px)');
    function receiptSemantics() {
      if (mobileReceipt.matches) { head.setAttribute('role', 'button'); head.setAttribute('tabindex', '0'); head.setAttribute('aria-controls', root.querySelector('[data-fmt-receipt-body]').id); head.setAttribute('aria-expanded', String(receipt.classList.contains('is-open'))); }
      else { head.removeAttribute('role'); head.removeAttribute('tabindex'); head.removeAttribute('aria-expanded'); head.removeAttribute('aria-controls'); }
    }
    receiptSemantics(); mobileReceipt.addEventListener('change', receiptSemantics);
    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && receipt.classList.contains('is-open') && receipt.contains(document.activeElement)) {
        event.preventDefault();
        receipt.classList.remove('is-open'); head.setAttribute('aria-expanded', 'false'); if (toggle) toggle.textContent = 'Show'; focusControl(head, true); syncReceiptClearance();
      }
    });
    head.addEventListener("keydown", function (event) { if (event.key === "Enter" || event.key === " ") { event.preventDefault(); head.click(); } });
    head.addEventListener("click", function () {
      if (!window.matchMedia("(max-width: 989px)").matches) return;
      receipt.classList.toggle("is-open");
      head.setAttribute("aria-expanded", String(receipt.classList.contains("is-open")));
      if (toggle) toggle.textContent = receipt.classList.contains("is-open") ? "Hide" : "Show";
      syncReceiptClearance();
    });
  }

  async function resetVisit() {
    if (submitting) return;
    submitting = true;
    var restartButton = root.querySelector('[data-restart]');
    if (restartButton) { restartButton.disabled = true; restartButton.textContent = 'Clearing your cart…'; }
    try {
      if (!window.FMTCartVisit || !window.FMTCartVisit.startNewProject) throw Error('We could not clear your cart. Your project is still saved. Reload this page and try again.');
      await window.FMTCartVisit.startNewProject();
      priceReview = null; restartPending = false;
    if (recovery) recovery.clear();
    recoveryConsent = false;
    S = JSON.parse(JSON.stringify(DEFAULTS));
    var fresh = visit ? visit.reset(S) : { projectId: 'fmt_' + crypto.randomUUID() };
    projectId = fresh.projectId; restored = false; restoredStep = 0; fromLink = null;
    railOpen = false; acknowledgedCart = '';
    render();
    focusControl(root.querySelector('.fmt-step__h'), false);
    // Refresh server-rendered cart drawer and header after the verified reset.
    if (typeof window.location.reload === 'function') window.location.reload();
    } catch (error) {
      S.error = error.message || 'We could not clear your cart. Your project is still saved; please try again.';
      render();
    } finally { submitting = false; }
  }
  function returnToVisit() {
    // Do not replace a project while its checkout reconciliation is pending.
    var recoveryStatus = recovery && recovery.getStatus ? recovery.getStatus().status : '';
    if (!visit || submitting || recoveryStatus === 'saving' || recoveryStatus === 'withdrawing' || (typeof document.hidden === 'boolean' && document.hidden)) return;
    var nextVisit = visit.resume();
    var currentContext = recovery && recovery.getContext ? recovery.getContext() : null;
    if (nextVisit.projectId === projectId && JSON.stringify(nextVisit.state) === JSON.stringify(S) &&
        JSON.stringify(visit.getRecoveryContext()) === JSON.stringify(currentContext)) return;
    if (nextVisit.projectId !== projectId) { acknowledgedCart = ''; railOpen = false; }
    projectId = nextVisit.projectId;
    S = CORE.normalize(nextVisit.state || DEFAULTS, CATALOG, DEFAULTS, STEPS.length);
    S.error = ''; S.quoteMode = false;
    restored = nextVisit.restored && S.formats.length > 0 && S.step > 0;
    restoredStep = S.step;
    if (!nextVisit.restored) { fromLink = null; applyContextFormat(); }
    if (recovery && recovery.destroy) recovery.destroy();
    recovery = createRecovery();
    recoveryConsent = !!(recovery && recovery.getContext && recovery.getContext());
    render();
  }
  if (root.addEventListener) ['pointerdown', 'keydown', 'input', 'change'].forEach(function (type) {
    root.addEventListener(type, function (event) {
      if (event.isTrusted === true && visit) visit.touch(S);
    }, true);
  });
  var visitWasAway = false;
  window.addEventListener('pagehide', function () { if (visit) visit.save(S); });
  window.addEventListener('pageshow', function (event) { if (event.persisted) returnToVisit(); });
  window.addEventListener('blur', function () { visitWasAway = true; });
  window.addEventListener('focus', function () { if (visitWasAway) { visitWasAway = false; returnToVisit(); } });
  if (document.addEventListener) document.addEventListener('visibilitychange', function () {
    if (document.hidden) visitWasAway = true;
    else if (visitWasAway) { visitWasAway = false; returnToVisit(); }
  });

  render();
})();
